
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type SearchPageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function SearchPageRT(): TemplateResult<SearchPageRTRootProps> {
    function scopeIsB2BShowExactFitBadgeShowLoadMore1() {
        var isB2B = !!window.Convermax.isB2B;
        var showExactFitBadge = this.isVehicleSelected && !this.responseMessages.includes('IncompatibleParts');
        var showLoadMore = this.pageTo !== this.totalHits;
        return _createElement('div', {
            'id': 'itemsBlock',
            'className': isB2B ? 'rocket-template-collection__b2b' : ''
        }, [this.FilterSearchBox(function () {
                return _createElement('div', { 'className': 'cm_desktop-hide cm_FilterSearchBox' }, _createElement('form', {
                    'className': 'cm_filter-search-box cm_search-box-root cm_search-box-root__filter',
                    'onSubmit': this.onSubmit
                }, _createElement('div', { 'className': 'cm_search-box_form-container' }, _createElement('input', {
                    'className': 'cm_filter-search-box__input  cm_searchInput',
                    'type': 'text',
                    'placeholder': window.Convermax.config?.searchBoxPlaceholderText || _translate(`search_box_placeholder`),
                    'value': this.value,
                    'onChange': this.onChange
                }), _createElement('span', { 'className': 'cm_search-box_clear-container' }, this.inputNotEmpty ? _createElement('span', {
                    'className': 'reset__button field__button cm_search-box_clear',
                    'onClick': this.clearInput,
                    'key': '489'
                }, '\n        ', _translate(`search_box_clear`), '\n      ') : null), _createElement('div', {
                    'className': 'cm_search-box_submit cm_button cm_button__primary',
                    'title': 'Search',
                    'aria-label': 'search button',
                    'data-cm-role': 'add-query'
                }, [
                    _createElement('svg', {
                        'className': 'icon icon-search cm_mobile-hide',
                        'aria-hidden': 'true',
                        'focusable': 'false',
                        'key': '8160'
                    }, _createElement('use', { 'href': '#icon-search' })),
                    _createElement('svg', {
                        'className': 'modal__toggle-open icon icon-search cm_desktop-hide',
                        'xmlns': 'http://www.w3.org/2000/svg',
                        'width': '22',
                        'height': '22',
                        'viewBox': '0 0 22 22',
                        'fill': 'none',
                        'key': '8162'
                    }, _createElement('path', {
                        'd': 'M19.2507 19.2502L14.4868 14.4863M14.4868 14.4863C15.7762 13.197 16.5005 11.4482 16.5005 9.62477C16.5005 7.80134 15.7762 6.05259 14.4868 4.76323C13.1974 3.47387 11.4487 2.74951 9.62526 2.74951C7.80183 2.74951 6.05308 3.47387 4.76372 4.76323C3.47436 6.05259 2.75 7.80134 2.75 9.62477C2.75 11.4482 3.47436 13.197 4.76372 14.4863C6.05308 15.7757 7.80183 16.5 9.62526 16.5C11.4487 16.5 13.1974 15.7757 14.4868 14.4863Z',
                        'stroke': 'currentColor',
                        'strokeLinecap': 'round',
                        'strokeLinejoin': 'round'
                    }))
                ]))));
            }, {
                widgetName: 'undefined',
                items: undefined
            })], [this.message(function () {
                function scopeUsageLimit1() {
                    var usageLimit = this.usageLimitExceeded();
                    return [usageLimit ? [_createElement('div', {
                                'className': 'cm_message__usage-limit-exceeded',
                                'key': '900'
                            }, '\n  ', _translate(`message_usage_limit_exceeded_header`, {  providerName: usageLimit.providerName  }), '\n  ', _createElement('p', {}, _translate(`message_usage_limit_exceeded_footer`, {  providerName: usageLimit.providerName  })))] : null];
                }
                return _createElement('div', { 'className': 'cm_message' }, scopeUsageLimit1.apply(this, []), this.demoPlanActive ? [_createElement('div', { 'key': '4060' }, '\n  Your store is currently running Convermax Search on a demo plan. The only limitation is that some product\n  images are replaced with a picture of a goose. Please upgrade your plan to remove this restriction.\n')] : null, this.trialExpired ? [_createElement('div', { 'key': '6830' }, _createElement('h2', { 'className': 'cm_message-header' }, 'YMM Search trial period has expired.'), '\n  Product information, including pricing and fitments, is outdated. This store runs on a limited trial version\n  of Convermax Year Make Model fitment search. Please contact\n  ', _createElement('a', {
                        'href': 'mailto:support@convermax.com',
                        'className': 'cm_message-link'
                    }, 'support@convermax.com'), ' to complete setup\n  or cancel the integration.\n')] : null, this.aggressiveWheels ? [_createElement('div', { 'key': '11330' }, _translate(`message_aggressive_wheels`, {  vehicleString : this. vehicleString  }))] : null, this.incompatibleParts ? [_createElement('div', {
                        'className': 'cm_message__incompatible',
                        'key': '12620'
                    }, _createElement('div', {}, _translate(`message_incompatible_text_results`, {  vehicleString : this. vehicleString  })))] : null, this.nonVehicleSpecificResults ? [_createElement('div', {
                        'className': 'cm_message__nothing-for-vehicle',
                        'key': '14490'
                    }, '\n  ', _translate(`message_non_vehicle_specific_results`, {  vehicleString : this. vehicleString  }), '\n  ', _createElement('a', {
                        'tabIndex': '0',
                        'className': 'cm_message-link',
                        'href': this.searchByVehicleUrl
                    }, _translate(`message_view_compatible_products`)))] : null, this.universalFitResults ? [_createElement('div', {
                        'className': 'cm_message__universal-results',
                        'key': '17720'
                    }, _translate(`message_universal_fit_results`))] : null, this.template === 'badRequest' ? _createElement('div', {
                    'className': 'cmTemplate_badRequest',
                    'key': '1927'
                }, _createElement('div', {}, '\n  ', _translate(`message_search_failed`), '\n  ', _createElement('a', {
                    'tabIndex': '0',
                    'className': 'cm_message-link',
                    'onClick': this.startOver
                }, _translate(`message_reset_search`)), _createElement('br', {}), this.error ? [
                    '\n    (',
                    this.error.status ? [
                        _createElement('b', { 'key': '22160' }, 'status:'),
                        ' ',
                        this.error.status,
                        ', '
                    ] : null,
                    this.error.userId ? [
                        _createElement('b', { 'key': '23030' }, 'id:'),
                        ' ',
                        this.error.userId,
                        ', '
                    ] : null,
                    this.error.timestamp ? [
                        _createElement('b', { 'key': '23860' }, 'timestamp:'),
                        ' ',
                        this.error.timestamp,
                        ', '
                    ] : null,
                    _createElement('b', { 'key': '21794' }, 'instance:'),
                    ' ',
                    this.error.instance,
                    ')'
                ] : null)) : null, this.template === 'corrected' ? _createElement('div', {
                    'className': 'cmTemplate_corrected',
                    'key': '2549'
                }, _createElement('div', {}, _translate(`message_query_corrected`, { 
                    originalQuery: this.
                    originalQuery, 
                    query
                : this.
                    query
                 }))) : null, this.template === 'networkError' ? _createElement('div', {
                    'className': 'cmTemplate_networkError',
                    'key': '2716'
                }, _createElement('div', {}, '\n  ', _translate(`message_network_error`), '\n  ', _createElement('br', {}), this.error ? [
                    '\n    (',
                    this.error.status ? [
                        _createElement('b', { 'key': '28980' }, 'status:'),
                        ' ',
                        this.error.status,
                        ', '
                    ] : null,
                    this.error.userId ? [
                        _createElement('b', { 'key': '29850' }, 'id:'),
                        ' ',
                        this.error.userId,
                        ', '
                    ] : null,
                    this.error.timestamp ? [
                        _createElement('b', { 'key': '30680' }, 'timestamp:'),
                        ' ',
                        this.error.timestamp,
                        ', '
                    ] : null,
                    _createElement('b', { 'key': '28614' }, 'instance:'),
                    ' ',
                    this.error.instance,
                    ')'
                ] : null)) : null, this.template === 'nothing' ? _createElement('div', {
                    'className': 'cmTemplate_nothing',
                    'key': '3231'
                }, _createElement('div', {}, '\n  ', _translate(`message_no_results`), '\n  ', this.query || this.isFacetsSelected || this.isSearchedByVehicle ? _createElement('a', {
                    'tabIndex': '0',
                    'className': 'cm_message-link',
                    'onClick': this.startOver,
                    'key': '3355'
                }, _translate(`message_reset_search`)) : null)) : null, this.template === 'partial' ? _createElement('div', {
                    'className': 'cmTemplate_partial',
                    'key': '3550'
                }, _createElement('div', {}, _translate(`message_query_partial`, {  originalQuery : this. originalQuery  }))) : null, this.template === 'timeout' ? _createElement('div', {
                    'className': 'cmTemplate_timeout',
                    'key': '3704'
                }, _createElement('div', {}, '\n  ', _translate(`message_timeout`), '\n  ', _createElement('a', {
                    'tabIndex': '0',
                    'className': 'cm_message-link',
                    'onClick': this.retry
                }, _translate(`message_retry_search`)))) : null, this.template === 'unknown' ? _createElement('div', {
                    'className': 'cmTemplate_unknown',
                    'key': '3944'
                }, _createElement('div', {}, '\n  ', _translate(`message_search_failed`), '\n  ', _createElement('a', {
                    'tabIndex': '0',
                    'className': 'cm_message-link',
                    'onClick': this.retry
                }, _translate(`message_retry_search`)), _createElement('br', {}), this.error ? [
                    '\n    (',
                    this.error.status ? [
                        _createElement('b', { 'key': '42230' }, 'status:'),
                        ' ',
                        this.error.status,
                        ', '
                    ] : null,
                    this.error.userId ? [
                        _createElement('b', { 'key': '43100' }, 'id:'),
                        ' ',
                        this.error.userId,
                        ', '
                    ] : null,
                    this.error.timestamp ? [
                        _createElement('b', { 'key': '43930' }, 'timestamp:'),
                        ' ',
                        this.error.timestamp,
                        ', '
                    ] : null,
                    _createElement('b', { 'key': '41864' }, 'instance:'),
                    ' ',
                    this.error.instance,
                    ')'
                ] : null)) : null);
            }, {
                widgetName: 'undefined',
                items: undefined
            })], [this.customMessage(function () {
                return _createElement('div', { 'className': 'cm_message cm_customMessage' }, []);
            }, {
                widgetName: 'undefined',
                items: undefined
            })], [this.SearchHeader(function () {
                return _createElement('div', { 'className': 'cm_SearchHeader' }, [this.facetDialogButton(function () {
                        return _createElement('div', { 'className': 'cm_facetDialogButton' }, [this.dialogButton(function () {
                                return _createElement('div', { 'className': 'cm_button cm_button__primary cm_dialogButton' }, '\n  ', _translate(`facet_dialog_open_button`), ' \n    ', this.withSelection ? [_createElement('svg', {
                                        'xmlns': 'http://www.w3.org/2000/svg',
                                        'width': '19',
                                        'height': '10',
                                        'viewBox': '0 0 19 10',
                                        'fill': 'none',
                                        'key': '1080'
                                    }, _createElement('path', {
                                        'd': 'M0 2L19 2',
                                        'stroke': '#1A1A1A'
                                    }), _createElement('path', {
                                        'd': 'M0 8L19 8',
                                        'stroke': '#1A1A1A'
                                    }), _createElement('circle', {
                                        'cx': '15',
                                        'cy': '2',
                                        'r': '2',
                                        'fill': '#1A1A1A'
                                    }), _createElement('circle', {
                                        'cx': '6',
                                        'cy': '8',
                                        'r': '2',
                                        'fill': '#1A1A1A'
                                    }))] : null, !this.withSelection ? [_createElement('svg', {
                                        'xmlns': 'http://www.w3.org/2000/svg',
                                        'width': '19',
                                        'height': '10',
                                        'viewBox': '0 0 19 10',
                                        'fill': 'none',
                                        'key': '4450'
                                    }, _createElement('path', {
                                        'd': 'M0 2L19 2',
                                        'stroke': '#1A1A1A'
                                    }), _createElement('path', {
                                        'd': 'M0 8L19 8',
                                        'stroke': '#1A1A1A'
                                    }), _createElement('circle', {
                                        'cx': '15',
                                        'cy': '2',
                                        'r': '2',
                                        'fill': '#1A1A1A'
                                    }), _createElement('circle', {
                                        'cx': '6',
                                        'cy': '8',
                                        'r': '2',
                                        'fill': '#1A1A1A'
                                    }))] : null);
                            }, {
                                widgetName: 'undefined',
                                items: undefined
                            })]);
                    }, {
                        widgetName: 'undefined',
                        items: undefined
                    })], _createElement('div', {
                    'className': 'cm_total-hits',
                    'role': 'status'
                }, _createElement('span', {}, this.totalHits, ' ', _translate(`total_products_count_title`))), _createElement('div', { 'className': 'cm_sort sort-by' }, _createElement('span', { 'className': 'sort-label' }, _translate(`sort_select_label`)), '\n  ', this.sortSelect, '\n'));
            }, {
                widgetName: 'search-header',
                items: undefined
            })], [this.FilterChips(function () {
                return _createElement('div', { 'className': 'cm_filterChips cm_filterChips__search-header cm_desktop-hide cm_FilterChips' }, [this.filterChips(function () {
                        function repeatChips1(chips, chipsIndex) {
                            return [chips(function () {
                                    function repeatI1_reviewChip(i, iIndex) {
                                        return _createElement('span', {
                                            'key': `${ this.field }|${ i }`,
                                            'className': 'cm_star cm_star__' + (!(this.value - i) || this.value - i < 0.25 ? 'empty' : this.value - i < 0.75 ? 'half' : 'full')
                                        });
                                    }
                                    return this.template === 'chip' ? _createElement('div', { 'className': 'facetdiv cmTemplate_chip' }, _createElement('a', {
                                        'className': 'facetentrykey',
                                        'tabIndex': '0',
                                        'role': 'listitem'
                                    }, _createElement('span', { 'className': 'cm_chip-name' }, this.name === 'filterQuery' ? _translate(`filter_search_box_current_search`) : this.name === 'query' ? _translate(`current_query_label`) : this.name, ':'), '\n  ', this.value, '\n'), _createElement('div', { 'className': 'facetentryval' }, [_createElement('svg', {
                                            'className': 'cm_icon cm_icon-times',
                                            'height': '20px',
                                            'role': 'img',
                                            'viewBox': '0 0 22 22',
                                            'key': '3500'
                                        }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))])) : this.template === 'reviewChip' ? _createElement('div', { 'className': 'facetdiv cmTemplate_reviewChip' }, _createElement.apply(this, [
                                        'a',
                                        {
                                            'className': 'facetentrykey',
                                            'tabIndex': '0',
                                            'role': 'listitem'
                                        },
                                        _createElement('span', { 'className': 'cm_chip-name' }, this.name, ': '),
                                        _map([
                                            0,
                                            1,
                                            2,
                                            3,
                                            4
                                        ], repeatI1_reviewChip.bind(this)),
                                        this.value !== '5' ? _createElement('span', { 'key': '391' }, ' and up') : null
                                    ]), _createElement('div', { 'className': 'facetentryval' }, [_createElement('svg', {
                                            'className': 'cm_icon cm_icon-times',
                                            'height': '20px',
                                            'role': 'img',
                                            'viewBox': '0 0 22 22',
                                            'key': '4900'
                                        }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))])) : this.template === 'rangeChip' ? _createElement('div', { 'className': 'facetdiv cmTemplate_rangeChip' }, _createElement('a', {
                                        'className': 'facetentrykey',
                                        'tabIndex': '0',
                                        'role': 'listitem'
                                    }, _createElement('span', { 'className': 'cm_chip-name' }, this.name, ':'), this.finite ? [
                                        this.selectedRange[0],
                                        ' ',
                                        _translate(`ranged_facet_range_delimiter`),
                                        ' ',
                                        this.selectedRange[1]
                                    ] : null, this.toPosInf ? [
                                        this.selectedRange[0],
                                        ' ',
                                        _translate(`ranged_facet_more`)
                                    ] : null, this.toNegInf ? [
                                        this.selectedRange[1],
                                        ' ',
                                        _translate(`ranged_facet_less`)
                                    ] : null), _createElement('div', { 'className': 'facetentryval' }, [_createElement('svg', {
                                            'className': 'cm_icon cm_icon-times',
                                            'height': '20px',
                                            'role': 'img',
                                            'viewBox': '0 0 22 22',
                                            'key': '5360'
                                        }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))])) : _createElement('div', { 'className': 'cmTemplate_Unknown' }, JSON.stringify(this));
                                }, { count: undefined })];
                        }
                        return _createElement('div', { 'className': 'cm_filterChips' }, _createElement('div', { 'className': 'facetholder' }, _createElement('div', { 'className': 'facetbody' }, _createElement.apply(this, [
                            'div',
                            {
                                'role': 'list',
                                'className': 'cmRepeater_chips'
                            },
                            _map(this.chips, repeatChips1.bind(this))
                        ]), _createElement('div', {
                            'className': 'facetdiv cm_filter-chips_button',
                            'data-cm-role': 'start-over'
                        }, _createElement('a', {
                            'className': 'facetentrykey',
                            'tabIndex': '0',
                            'role': 'listitem'
                        }, _translate(`selected_facets_clear`))))));
                    }, {
                        widgetName: 'filter-chips',
                        items: undefined
                    })]);
            }, {
                widgetName: 'undefined',
                items: undefined
            })], [this.SearchResult(function () {
                function repeatItems1(items, itemsIndex) {
                    return [items(function () {
                            function mergeProps(inline, external) {
                                var res = Object.assign({}, inline, external);
                                if (inline.hasOwnProperty('style')) {
                                    res.style = _.defaults(res.style, inline.style);
                                }
                                if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                                    res.className = external.className + ' ' + inline.className;
                                }
                                return res;
                            }
                            function repeatBadge2(badge, badgeIndex) {
                                return _createElement('span', {
                                    'className': 'badge badge--bottom-left',
                                    'key': badge
                                }, '\n              ', _translate(`product_badge_${ badge }`) || badge, '\n            ');
                            }
                            function repeatI3(i, iIndex) {
                                return _createElement('span', {
                                    'key': i,
                                    'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                                });
                            }
                            function scopeDiscount4() {
                                var discount = this.calcDiscount(this.price, this.compare_at_price);
                                return _createElement('div', { 'className': 'price' + (this.on_sale ? ' price--on-sale' : '') }, _createElement('div', { 'className': 'price__container' }, !this.on_sale ? _createElement('div', {
                                    'className': 'price__regular',
                                    'key': '11024'
                                }, _createElement('span', { 'className': 'price-item price-item--regular' }, this.formatPrice(this.price))) : null, this.on_sale ? _createElement('div', {
                                    'className': 'price__sale',
                                    'key': '11215'
                                }, _createElement('span', { 'className': 'price-item price-item--last price-item--sale' }, this.price_varies ? _createElement('span', { 'key': '11360' }, _translate(`price_from`), ' ') : null, '\n                    ', this.formatPrice(this.min_price || this.price), '\n                  '), _createElement('span', { 'className': 'price-item price-item--regular' }, '\n                     ', _createElement('del', {}, this.formatPrice(this.compare_at_price)))) : null), this.on_sale && discount > 0 ? _createElement('div', {
                                    'className': 'cm_sale-percent',
                                    'key': '11754'
                                }, '-', discount, '%') : null);
                            }
                            return _createElement('li', { 'className': 'grid__item' }, _createElement('div', { 'className': 'card-wrapper product-card-wrapper' }, _createElement('div', { 'className': 'card card--standard card--media' }, _createElement('div', { 'className': 'card__inner color-accent-1 gradient ratio' }, _createElement('div', { 'className': 'card__media' }, _createElement('div', { 'className': 'media media--transparent media--hover-effect' }, _createElement('img', {
                                'className': 'motion-reduce',
                                'src': this.imageOrDefault(this.resizeImage(this.image)),
                                'alt': this.removeHTML(this.title),
                                'onError': this.onImageError
                            }))), _createElement('div', { 'className': 'card__content' }, _createElement('div', { 'className': 'card__information' }, _createElement('h3', { 'className': 'card__heading' }, _createElement('a', mergeProps({
                                'href': this.url,
                                'className': 'card-link'
                            }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })))), _createElement.apply(this, [
                                'div',
                                { 'className': 'card__badge top left' },
                                showExactFitBadge && this.Fitment === 'Vehicle Specific' ? _createElement('div', {
                                    'className': 'badge badge--bottom-left badge--exact-fit',
                                    'key': '875'
                                }, '\n              ', _translate(`product_badge_vehicle_specific`) || 'Específico', '\n            ') : null,
                                this.Fitment === 'Universal Fit' ? _createElement('div', {
                                    'className': 'badge badge--bottom-left badge--universal',
                                    'key': '1128'
                                }, _createElement('span', { 'className': 'badge-label' }, _translate(`product_badge_universal`) || 'Universal')) : null,
                                this.on_sale ? _createElement('span', {
                                    'className': 'badge badge--bottom-left',
                                    'key': '1369'
                                }, ' ', _translate(`product_sale_badge`), ' ') : null,
                                this.product_badges ? _map(this.product_badges, repeatBadge2.bind(this)) : null
                            ])), _createElement('a', mergeProps({
                                'href': this.url,
                                'className': 'card-link card-link-custom'
                            }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })), !this.out_of_stock ? _createElement('div', {
                                'className': 'quick-add no-js-hidden',
                                'key': '1919'
                            }, this.variant_ids.length === 1 ? _createElement('convermax-product-form', { 'key': '1993' }, _createElement('form', {
                                'method': 'post',
                                'action': '/cart/add',
                                'id': 'quick-add-cm_results__product-grid' + this.id,
                                'acceptCharset': 'UTF-8',
                                'className': 'form',
                                'encType': 'multipart/form-data',
                                'noValidate': 'novalidate',
                                'data-type': 'add-to-cart-form'
                            }, _createElement('input', {
                                'type': 'hidden',
                                'name': 'form_type',
                                'value': 'product'
                            }), _createElement('input', {
                                'type': 'hidden',
                                'name': 'utf8',
                                'value': '\u2713'
                            }), _createElement('input', {
                                'type': 'hidden',
                                'name': 'id',
                                'value': this.variant_ids
                            }), this.fitsTheVehicle && !window.Convermax.config?.hideVerifyOnCartItems ? _createElement('input', {
                                'type': 'hidden',
                                'name': 'properties[Fitment]',
                                'value': this.getVerifyFitmentOrderNotes(this.fitsTheVehicle),
                                'key': '2499'
                            }) : null, _createElement('button', {
                                'id': 'quick-add-cm_results__product-grid' + this.id + '-submit',
                                'type': 'submit',
                                'name': 'add',
                                'className': 'quick-add__submit button button--full-width button--secondary',
                                'aria-haspopup': 'dialog',
                                'aria-labelledby': 'quick-add-cm_results__product-grid' + this.id + '-submit title-cm_results__product-grid-' + this.id,
                                'aria-live': 'polite',
                                'data-sold-out-message': 'true'
                            }, _createElement('span', {}, _translate(`product_add_to_cart`)), _createElement('span', { 'className': 'sold-out-message hidden' }, _translate(`product_out_of_stock`)), _createElement('span', { 'className': 'icon-add' }, [_createElement('svg', {
                                    'xmlns': 'http://www.w3.org/2000/svg',
                                    'width': '16',
                                    'height': '16',
                                    'viewBox': '0 0 16 16',
                                    'fill': 'none',
                                    'key': '32780'
                                }, _createElement('g', { 'clipPath': 'url(#clip0_3628_301440)' }, _createElement('path', {
                                    'd': 'M5.33073 14.6673C5.69892 14.6673 5.9974 14.3688 5.9974 14.0007C5.9974 13.6325 5.69892 13.334 5.33073 13.334C4.96254 13.334 4.66406 13.6325 4.66406 14.0007C4.66406 14.3688 4.96254 14.6673 5.33073 14.6673Z',
                                    'stroke': 'black',
                                    'strokeLinecap': 'round',
                                    'strokeLinejoin': 'round'
                                }), _createElement('path', {
                                    'd': 'M12.6667 14.6673C13.0349 14.6673 13.3333 14.3688 13.3333 14.0007C13.3333 13.6325 13.0349 13.334 12.6667 13.334C12.2985 13.334 12 13.6325 12 14.0007C12 14.3688 12.2985 14.6673 12.6667 14.6673Z',
                                    'stroke': 'black',
                                    'strokeLinecap': 'round',
                                    'strokeLinejoin': 'round'
                                }), _createElement('path', {
                                    'd': 'M1.36719 1.36719H2.70052L4.47385 9.64719C4.53891 9.95043 4.70763 10.2215 4.951 10.4138C5.19436 10.606 5.49712 10.7074 5.80719 10.7005H12.3272C12.6306 10.7 12.9248 10.596 13.1612 10.4057C13.3976 10.2154 13.5619 9.95021 13.6272 9.65385L14.7272 4.70052H3.41385',
                                    'stroke': 'black',
                                    'strokeLinecap': 'round',
                                    'strokeLinejoin': 'round'
                                })), _createElement('defs', {}, _createElement('clipPath', { 'id': 'clip0_3628_301440' }, _createElement('rect', {
                                    'width': '16',
                                    'height': '16',
                                    'fill': 'white'
                                }))))]), _createElement('div', { 'className': 'loading-overlay__spinner hidden' }, [_createElement('svg', {
                                    'aria-hidden': 'true',
                                    'focusable': 'false',
                                    'className': 'spinner',
                                    'viewBox': '0 0 66 66',
                                    'xmlns': 'http://www.w3.org/2000/svg',
                                    'key': '45640'
                                }, _createElement('circle', {
                                    'className': 'path',
                                    'fill': 'none',
                                    'strokeWidth': '6',
                                    'cx': '33',
                                    'cy': '33',
                                    'r': '30'
                                }))])), _createElement('input', {
                                'type': 'hidden',
                                'name': 'product-id',
                                'value': this.id
                            }), _createElement('input', {
                                'type': 'hidden',
                                'name': 'section-id',
                                'value': 'cm_results__product-grid'
                            }))) : null, this.variant_ids.length > 1 ? [
                                _createElement('convermax-modal-opener', {
                                    'data-modal': '#QuickAdd-' + this.id,
                                    'key': '50611'
                                }, _createElement('button', {
                                    'id': 'cm_results__product-grid' + this.id + '-submit',
                                    'type': 'submit',
                                    'name': 'add',
                                    'className': 'quick-add__submit button button--full-width button--secondary',
                                    'aria-haspopup': 'dialog',
                                    'aria-labelledby': 'cm_results__product-grid' + this.id + '-submit cm_results__product-grid-' + this.id,
                                    'data-product-url': this.url
                                }, '\n                ', _translate(`product_add_to_cart`), '\n                ', [_createElement('svg', {
                                        'xmlns': 'http://www.w3.org/2000/svg',
                                        'width': '16',
                                        'height': '16',
                                        'viewBox': '0 0 16 16',
                                        'fill': 'none',
                                        'key': '55630'
                                    }, _createElement('g', { 'clipPath': 'url(#clip0_3628_301440)' }, _createElement('path', {
                                        'd': 'M5.33073 14.6673C5.69892 14.6673 5.9974 14.3688 5.9974 14.0007C5.9974 13.6325 5.69892 13.334 5.33073 13.334C4.96254 13.334 4.66406 13.6325 4.66406 14.0007C4.66406 14.3688 4.96254 14.6673 5.33073 14.6673Z',
                                        'stroke': 'black',
                                        'strokeLinecap': 'round',
                                        'strokeLinejoin': 'round'
                                    }), _createElement('path', {
                                        'd': 'M12.6667 14.6673C13.0349 14.6673 13.3333 14.3688 13.3333 14.0007C13.3333 13.6325 13.0349 13.334 12.6667 13.334C12.2985 13.334 12 13.6325 12 14.0007C12 14.3688 12.2985 14.6673 12.6667 14.6673Z',
                                        'stroke': 'black',
                                        'strokeLinecap': 'round',
                                        'strokeLinejoin': 'round'
                                    }), _createElement('path', {
                                        'd': 'M1.36719 1.36719H2.70052L4.47385 9.64719C4.53891 9.95043 4.70763 10.2215 4.951 10.4138C5.19436 10.606 5.49712 10.7074 5.80719 10.7005H12.3272C12.6306 10.7 12.9248 10.596 13.1612 10.4057C13.3976 10.2154 13.5619 9.95021 13.6272 9.65385L14.7272 4.70052H3.41385',
                                        'stroke': 'black',
                                        'strokeLinecap': 'round',
                                        'strokeLinejoin': 'round'
                                    })), _createElement('defs', {}, _createElement('clipPath', { 'id': 'clip0_3628_301440' }, _createElement('rect', {
                                        'width': '16',
                                        'height': '16',
                                        'fill': 'white'
                                    }))))], _createElement('div', { 'className': 'loading-overlay__spinner hidden' }, [_createElement('svg', {
                                        'aria-hidden': 'true',
                                        'focusable': 'false',
                                        'className': 'spinner',
                                        'viewBox': '0 0 66 66',
                                        'xmlns': 'http://www.w3.org/2000/svg',
                                        'key': '68250'
                                    }, _createElement('circle', {
                                        'className': 'path',
                                        'fill': 'none',
                                        'strokeWidth': '6',
                                        'cx': '33',
                                        'cy': '33',
                                        'r': '30'
                                    }))]))),
                                _createElement('convermax-quick-add-modal', {
                                    'id': 'QuickAdd-' + this.id,
                                    'key': '50613',
                                    'class': 'quick-add-modal quick-add-modal__b2b'
                                }, _createElement('div', {
                                    'role': 'dialog',
                                    'aria-label': 'Choose options for ' + this.removeHTML(this.title),
                                    'aria-modal': 'true',
                                    'className': 'quick-add-modal__content global-settings-popup',
                                    'tabIndex': '-1'
                                }, _createElement('button', {
                                    'id': 'ModalClose-' + this.id,
                                    'type': 'button',
                                    'className': 'quick-add-modal__toggle',
                                    'aria-label': 'Close'
                                }, [_createElement('svg', {
                                        'xmlns': 'http://www.w3.org/2000/svg',
                                        'aria-hidden': 'true',
                                        'focusable': 'false',
                                        'className': 'icon icon-close',
                                        'fill': 'none',
                                        'viewBox': '0 0 18 17',
                                        'key': '75590'
                                    }, _createElement('path', {
                                        'd': 'M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z',
                                        'fill': 'currentColor'
                                    }))]), _createElement('div', {
                                    'id': 'QuickAddInfo-' + this.id,
                                    'className': 'quick-add-modal__content-info rocket-main-product'
                                })))
                            ] : null) : null, _createElement('div', { 'className': 'card__wishlist' }, _createElement('button', {
                                'aria-label': 'Add to Wishlist',
                                'data-with-epi': 'true',
                                'className': 'swym-button swym-add-to-wishlist-view-product product_' + this.id + ' swym-icontext swym-heart swym-loaded',
                                'data-product-swatch-id': this.id,
                                'data-swaction': 'addToWishlist',
                                'data-product-id': this.id,
                                'data-variant-id': this.variant_ids[0],
                                'data-product-url': window.location.protocol + '//' + window.location.host + this.url
                            }, [_createElement('svg', {
                                    'xmlns': 'http://www.w3.org/2000/svg',
                                    'width': '22',
                                    'height': '22',
                                    'viewBox': '0 0 22 22',
                                    'fill': 'none',
                                    'key': '86410'
                                }, _createElement('path', {
                                    'd': 'M16.2137 12.7074C17.387 11.5719 18.5762 10.2107 18.5762 8.42963C18.5762 7.2951 18.1198 6.20703 17.3076 5.40479C16.4953 4.60255 15.3936 4.15186 14.2449 4.15186C12.8589 4.15186 11.8824 4.54074 10.7012 5.70741C9.51992 4.54074 8.54342 4.15186 7.15742 4.15186C6.0087 4.15186 4.90703 4.60255 4.09477 5.40479C3.2825 6.20703 2.82617 7.2951 2.82617 8.42963C2.82617 10.2185 4.00742 11.5796 5.18867 12.7074L10.7012 18.1519L16.2137 12.7074Z',
                                    'stroke': 'black',
                                    'strokeLinecap': 'round',
                                    'strokeLinejoin': 'round'
                                }))]))), _createElement('div', { 'className': 'card__content' }, _createElement('div', { 'className': 'card__information' }, _createElement('div', { 'className': 'card__top--infor' }, _createElement('div', { 'className': 'card__vendor' }, this.vendor_image ? _createElement('img', {
                                'src': this.imageOrDefault(this.resizeImage(this.vendor_image)),
                                'alt': this.removeHTML(this.vendor),
                                'onError': this.onImageError,
                                'key': '9489'
                            }) : null, !this.vendor_image ? _createElement('span', Object.assign({}, { 'key': '9668' }, { dangerouslySetInnerHTML: { __html: typeof this.vendor === 'undefined' ? '' : this.vendor } })) : null), this.sku ? _createElement('div', {
                                'className': 'card__sku',
                                'key': '9861'
                            }, _createElement('span', {}, 'Sku:'), _createElement('span', { dangerouslySetInnerHTML: { __html: typeof this.sku === 'undefined' ? '' : this.sku } })) : null), _createElement('h3', { 'className': 'card__heading h5' }, _createElement('a', mergeProps({
                                'href': this.url,
                                'className': 'card-link'
                            }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } }))), [this.review_count ? _createElement.apply(this, [
                                    'div',
                                    {
                                        'className': 'cm_review-stars',
                                        'key': '103570'
                                    },
                                    _map([
                                        0,
                                        1,
                                        2,
                                        3,
                                        4
                                    ], repeatI3.bind(this)),
                                    _createElement('span', { 'className': 'cm_review-count' }, '(', this.review_count, ')')
                                ]) : null], _createElement('div', { 'className': 'card-information' }, scopeDiscount4.apply(this, [])))), _createElement('div', { 'className': 'card__content--status' }, _createElement('div', { 'className': 'card-info-status__product' }, this.rocket_procduct_pendiente ? [
                                _createElement('span', {
                                    'className': 'icon',
                                    'key': '120141'
                                }, [_createElement('svg', {
                                        'xmlns': 'http://www.w3.org/2000/svg',
                                        'width': '14',
                                        'height': '14',
                                        'viewBox': '0 0 14 14',
                                        'fill': 'none',
                                        'key': '121120'
                                    }, _createElement('path', {
                                        'd': 'M7 3.5V7L9.33333 8.16667',
                                        'stroke': '#ECB621',
                                        'strokeWidth': '1.5',
                                        'strokeLinecap': 'round',
                                        'strokeLinejoin': 'round'
                                    }), _createElement('path', {
                                        'd': 'M9.33261 12.3429C8.28411 12.801 7.12405 12.9405 5.99683 12.7443C4.8696 12.548 3.82499 12.0246 2.99298 11.2391C2.16098 10.4537 1.57834 9.44092 1.31758 8.32685C1.05681 7.21278 1.12944 6.04662 1.52642 4.97351C1.92339 3.9004 2.62719 2.96773 3.55022 2.29158C4.47324 1.61543 5.57473 1.22566 6.7176 1.17078C7.86046 1.1159 8.99423 1.39833 9.9778 1.98292C10.9614 2.56751 11.7513 3.42845 12.2493 4.45858',
                                        'stroke': '#ECB621',
                                        'strokeWidth': '1.5',
                                        'strokeLinecap': 'round',
                                        'strokeLinejoin': 'round'
                                    }), _createElement('path', {
                                        'd': 'M11.6641 6.70801V10.208',
                                        'stroke': '#ECB621',
                                        'strokeWidth': '1.5',
                                        'strokeLinecap': 'round',
                                        'strokeLinejoin': 'round'
                                    }), _createElement('path', {
                                        'd': 'M11.6641 12.542H11.6707',
                                        'stroke': '#ECB621',
                                        'strokeWidth': '1.5',
                                        'strokeLinecap': 'round',
                                        'strokeLinejoin': 'round'
                                    }))]),
                                _createElement('span', {
                                    'className': 'text',
                                    'key': '120143'
                                }, _translate(`product_stock_pending`))
                            ] : null, !this.rocket_procduct_pendiente ? [
                                !this.out_of_stock ? [
                                    _createElement('span', {
                                        'className': 'icon',
                                        'key': '132801'
                                    }, [_createElement('svg', {
                                            'xmlns': 'http://www.w3.org/2000/svg',
                                            'width': '16',
                                            'height': '16',
                                            'viewBox': '0 0 16 16',
                                            'fill': 'none',
                                            'key': '133700'
                                        }, _createElement('path', {
                                            'd': 'M13.3008 4.5498L6.42578 11.4248L3.30078 8.2998',
                                            'stroke': '#0CB73F',
                                            'strokeWidth': '1.5',
                                            'strokeLinecap': 'round',
                                            'strokeLinejoin': 'round'
                                        }))]),
                                    _createElement('span', {
                                        'className': 'text',
                                        'key': '132803'
                                    }, _translate(`product_stock_available`))
                                ] : null,
                                this.out_of_stock ? [
                                    _createElement('span', {
                                        'className': 'icon',
                                        'key': '137811'
                                    }, [_createElement('svg', {
                                            'xmlns': 'http://www.w3.org/2000/svg',
                                            'width': '14',
                                            'height': '14',
                                            'viewBox': '0 0 14 14',
                                            'fill': 'none',
                                            'key': '138700'
                                        }, _createElement('path', {
                                            'd': 'M10.5 3.5L3.5 10.5',
                                            'stroke': '#EF4A4A',
                                            'strokeWidth': '1.5',
                                            'strokeLinecap': 'round',
                                            'strokeLinejoin': 'round'
                                        }), _createElement('path', {
                                            'd': 'M3.5 3.5L10.5 10.5',
                                            'stroke': '#EF4A4A',
                                            'strokeWidth': '1.5',
                                            'strokeLinecap': 'round',
                                            'strokeLinejoin': 'round'
                                        }))]),
                                    _createElement('span', {
                                        'className': 'text',
                                        'key': '137813'
                                    }, _translate(`product_out_of_stock`))
                                ] : null
                            ] : null), this.variant_ids?.length > 1 ? _createElement('div', {
                                'className': 'card-info-status__color',
                                'key': '14398'
                            }, _createElement('a', { 'href': this.url }, _createElement('span', { 'className': 'text' }, '+ ', _translate(`product_options`)))) : null))));
                        }, { count: undefined })];
                }
                function repeatItems2(items, itemsIndex) {
                    return [items(function () {
                            function mergeProps(inline, external) {
                                var res = Object.assign({}, inline, external);
                                if (inline.hasOwnProperty('style')) {
                                    res.style = _.defaults(res.style, inline.style);
                                }
                                if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                                    res.className = external.className + ' ' + inline.className;
                                }
                                return res;
                            }
                            function repeatBadge2(badge, badgeIndex) {
                                return _createElement('span', {
                                    'className': 'badge badge--bottom-left color-accent-1',
                                    'key': badge
                                }, '\n            ', _translate(`product_badge_${ badge }`) || badge, '\n          ');
                            }
                            function repeatI3(i, iIndex) {
                                return _createElement('span', {
                                    'key': i,
                                    'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                                });
                            }
                            function scopeDiscount4() {
                                var discount = this.calcDiscount(this.price, this.compare_at_price);
                                return _createElement('div', { 'className': 'price' + (this.on_sale ? ' price--on-sale' : '') }, _createElement('div', { 'className': 'price__container' }, !this.on_sale ? _createElement('div', {
                                    'className': 'price__regular',
                                    'key': '16013'
                                }, _createElement('span', { 'className': 'price-item price-item--regular' }, this.price_varies ? _createElement('span', { 'key': '16148' }, _translate(`price_from`), ' ') : null, '\n                    ', this.formatPrice(this.min_price || this.price), '\n                  ')) : null, this.on_sale ? _createElement('div', {
                                    'className': 'price__sale',
                                    'key': '16350'
                                }, _createElement('span', { 'className': 'price-item price-item--last price-item--sale' }, this.price_varies ? _createElement('span', { 'key': '16495' }, _translate(`price_from`), ' ') : null, '\n                    ', this.formatPrice(this.min_price || this.price), '\n                  '), _createElement('span', { 'className': 'price-item price-item--regular' }, '\n                     ', _createElement('del', {}, this.formatPrice(this.compare_at_price)))) : null), this.on_sale && discount > 0 ? _createElement('div', {
                                    'className': 'cm_sale-percent',
                                    'key': '16889'
                                }, '-', discount, '%') : null, _createElement('div', { 'className': 'cm_price-b2b-tax' }, '(', _translate(`price_excluding_tax_label`), ')'));
                            }
                            return _createElement('li', { 'className': 'grid__item' + (this.is_promotional_item ? ' product-grid__banner' : '') }, !this.is_promotional_item ? [_createElement('div', {
                                    'className': 'card-wrapper product-card-wrapper underline-links-hover card-wrapper__b2b',
                                    'key': '1160'
                                }, _createElement('div', { 'className': 'card card--standard card--media' }, _createElement('div', { 'className': 'card__inner color-accent-1 gradient ratio' }, _createElement('div', { 'className': 'card__media' }, _createElement('div', { 'className': 'media media--transparent media--hover-effect' }, _createElement('img', {
                                    'className': 'motion-reduce',
                                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                                    'alt': this.removeHTML(this.title),
                                    'onError': this.onImageError,
                                    'width': '205',
                                    'height': '205'
                                }))), _createElement('div', { 'className': 'card__content' }, _createElement('div', { 'className': 'card__information' }, _createElement('h3', { 'className': 'card__heading' }, _createElement('a', mergeProps({
                                    'href': this.url,
                                    'className': 'card-link'
                                }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })))), _createElement.apply(this, [
                                    'div',
                                    { 'className': 'card__badge top left' },
                                    showExactFitBadge && this.Fitment === 'Vehicle Specific' ? _createElement('div', {
                                        'className': 'badge badge--bottom-left badge--exact-fit',
                                        'key': '1046'
                                    }, '\n            ', _translate(`product_badge_vehicle_specific`) || 'Específico', '\n          ') : null,
                                    this.Fitment === 'Universal Fit' ? _createElement('div', {
                                        'className': 'badge badge--bottom-left badge--universal',
                                        'key': '1293'
                                    }, _createElement('span', { 'className': 'badge-label' }, _translate(`product_badge_universal`) || 'Universal')) : null,
                                    this.product_badges ? _map(this.product_badges, repeatBadge2.bind(this)) : null
                                ])), _createElement('a', mergeProps({
                                    'href': this.url,
                                    'className': 'card-link card-link-custom'
                                }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })), _createElement('div', { 'className': 'card__feature card__feature--top' }, _createElement('div', { 'className': 'quick-view' }, _createElement('convermax-modal-opener', { 'data-modal': '#QuickView-' + this.id + '-mb' }, _createElement('button', {
                                    'id': 'cm_results__product-grid' + this.id + '-mb',
                                    'type': 'submit',
                                    'name': 'addQuickView',
                                    'className': 'quick-view__submit button',
                                    'aria-haspopup': 'dialog',
                                    'aria-labelledby': 'cm_results__product-grid' + this.id + '-mb cm_results__product-grid-' + this.id + '-qv',
                                    'data-product-url': this.url + '?view=function_quickview'
                                }, _createElement('span', { 'className': 'icon-quick-view' }, [_createElement('svg', {
                                        'xmlns': 'http://www.w3.org/2000/svg',
                                        'width': '24',
                                        'height': '24',
                                        'viewBox': '0 0 24 24',
                                        'fill': 'none',
                                        'key': '24780'
                                    }, _createElement('path', {
                                        'd': 'M2.06251 12.3474C1.97916 12.1229 1.97916 11.8759 2.06251 11.6514C2.87421 9.68324 4.25202 8.00042 6.02128 6.81628C7.79053 5.63214 9.87155 5 12.0005 5C14.1295 5 16.2105 5.63214 17.9797 6.81628C19.749 8.00042 21.1268 9.68324 21.9385 11.6514C22.0218 11.8759 22.0218 12.1229 21.9385 12.3474C21.1268 14.3155 19.749 15.9983 17.9797 17.1825C16.2105 18.3666 14.1295 18.9988 12.0005 18.9988C9.87155 18.9988 7.79053 18.3666 6.02128 17.1825C4.25202 15.9983 2.87421 14.3155 2.06251 12.3474Z',
                                        'stroke': 'currentColor',
                                        'strokeWidth': '1.2',
                                        'strokeLinecap': 'round',
                                        'strokeLinejoin': 'round'
                                    }), _createElement('path', {
                                        'd': 'M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z',
                                        'stroke': 'currentColor',
                                        'strokeWidth': '1.2',
                                        'strokeLinecap': 'round',
                                        'strokeLinejoin': 'round'
                                    }))]), _createElement('div', { 'className': 'loading-overlay__spinner hidden' }, [_createElement('svg', {
                                        'aria-hidden': 'true',
                                        'focusable': 'false',
                                        'className': 'spinner',
                                        'viewBox': '0 0 66 66',
                                        'xmlns': 'http://www.w3.org/2000/svg',
                                        'key': '34950'
                                    }, _createElement('circle', {
                                        'className': 'path',
                                        'fill': 'none',
                                        'strokeWidth': '6',
                                        'cx': '33',
                                        'cy': '33',
                                        'r': '30'
                                    }))]))), _createElement('convermax-quick-add-modal', {
                                    'id': 'QuickView-' + this.id + '-mb',
                                    'class': 'quick-add-modal quick-view-modal quick-add-modal_all'
                                }, _createElement('div', {
                                    'role': 'dialog',
                                    'aria-label': this.removeHTML(this.title),
                                    'aria-modal': 'true',
                                    'className': 'quick-add-modal__content global-settings-popup',
                                    'tabIndex': '-1'
                                }, _createElement('button', {
                                    'id': 'ModalClose-' + this.id,
                                    'type': 'button',
                                    'className': 'quick-add-modal__toggle'
                                }, [_createElement('svg', {
                                        'xmlns': 'http://www.w3.org/2000/svg',
                                        'aria-hidden': 'true',
                                        'focusable': 'false',
                                        'className': 'icon icon-close',
                                        'fill': 'none',
                                        'viewBox': '0 0 18 17',
                                        'key': '41970'
                                    }, _createElement('path', {
                                        'd': 'M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z',
                                        'fill': 'currentColor'
                                    }))]), _createElement('div', {
                                    'id': 'QuickAddInfo-' + this.id,
                                    'className': 'quick-add-modal__content-info rocket--product-quickView rocket-main-product'
                                })))), !this.out_of_stock ? _createElement('div', {
                                    'className': 'quick-add no-js-hidden',
                                    'key': '4841'
                                }, this.variant_ids.length === 1 ? [_createElement('convermax-product-form', {
                                        'data-section-id': 'cm_results__product-grid',
                                        'key': '49151'
                                    }, _createElement('div', {
                                        'className': 'product-form__error-message-wrapper',
                                        'role': 'alert',
                                        'hidden': true
                                    }, [_createElement('svg', {
                                            'aria-hidden': 'true',
                                            'focusable': 'false',
                                            'className': 'icon icon-error cm_icon cm_icon-alert',
                                            'viewBox': '0 0 13 13',
                                            'key': '51490'
                                        }, _createElement('circle', {
                                            'cx': '6.5',
                                            'cy': '6.50049',
                                            'r': '5.5',
                                            'stroke': 'white',
                                            'strokeWidth': '2'
                                        }), _createElement('circle', {
                                            'cx': '6.5',
                                            'cy': '6.5',
                                            'r': '5.5',
                                            'fill': '#EB001B',
                                            'stroke': '#EB001B',
                                            'strokeWidth': '0.7'
                                        }), _createElement('path', {
                                            'd': 'M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z',
                                            'fill': 'white'
                                        }), _createElement('path', {
                                            'd': 'M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z',
                                            'fill': 'white',
                                            'stroke': '#EB001B',
                                            'strokeWidth': '0.7'
                                        }))], _createElement('span', { 'className': 'product-form__error-message' })), _createElement('form', {
                                        'method': 'post',
                                        'action': '/cart/add',
                                        'id': 'quick-add-cm_results__product-grid' + this.id,
                                        'acceptCharset': 'UTF-8',
                                        'className': 'form',
                                        'encType': 'multipart/form-data',
                                        'noValidate': 'novalidate',
                                        'data-type': 'add-to-cart-form'
                                    }, _createElement('input', {
                                        'type': 'hidden',
                                        'name': 'form_type',
                                        'value': 'product'
                                    }), _createElement('input', {
                                        'type': 'hidden',
                                        'name': 'utf8',
                                        'value': '\u2713'
                                    }), _createElement('input', {
                                        'type': 'hidden',
                                        'name': 'id',
                                        'value': this.variant_ids[0]
                                    }), this.fitsTheVehicle && !window.Convermax.config?.hideVerifyOnCartItems ? _createElement('input', {
                                        'type': 'hidden',
                                        'name': 'properties[Fitment]',
                                        'value': this.getVerifyFitmentOrderNotes(this.fitsTheVehicle),
                                        'key': '6716'
                                    }) : null, _createElement('div', { 'className': 'quick-add__wrapper' }, _createElement('input', {
                                        'className': 'quantity__input',
                                        'type': 'hidden',
                                        'name': 'quantity',
                                        'value': '1'
                                    }), _createElement('button', {
                                        'id': 'quick-add-cm_results__product-grid' + this.id + '-submit',
                                        'type': 'submit',
                                        'name': 'add',
                                        'className': 'quick-add__submit button button--full-width button--secondary',
                                        'aria-haspopup': 'dialog',
                                        'aria-labelledby': 'quick-add-cm_results__product-grid' + this.id + '-submit cm_results__product-grid-' + this.id,
                                        'aria-live': 'polite',
                                        'data-sold-out-message': 'true'
                                    }, _createElement('span', { 'className': 'icon-quick-add' }, [_createElement('svg', {
                                            'xmlns': 'http://www.w3.org/2000/svg',
                                            'width': '16',
                                            'height': '16',
                                            'viewBox': '0 0 16 16',
                                            'fill': 'none',
                                            'key': '74820'
                                        }, _createElement('g', { 'clip-path': 'url(#clip0_3628_301440)' }, _createElement('path', {
                                            'd': 'M5.33073 14.6673C5.69892 14.6673 5.9974 14.3688 5.9974 14.0007C5.9974 13.6325 5.69892 13.334 5.33073 13.334C4.96254 13.334 4.66406 13.6325 4.66406 14.0007C4.66406 14.3688 4.96254 14.6673 5.33073 14.6673Z',
                                            'stroke': 'currentColor',
                                            'strokeLinecap': 'round',
                                            'strokeLinejoin': 'round'
                                        }), _createElement('path', {
                                            'd': 'M12.6667 14.6673C13.0349 14.6673 13.3333 14.3688 13.3333 14.0007C13.3333 13.6325 13.0349 13.334 12.6667 13.334C12.2985 13.334 12 13.6325 12 14.0007C12 14.3688 12.2985 14.6673 12.6667 14.6673Z',
                                            'stroke': 'currentColor',
                                            'strokeLinecap': 'round',
                                            'strokeLinejoin': 'round'
                                        }), _createElement('path', {
                                            'd': 'M1.36719 1.36719H2.70052L4.47385 9.64719C4.53891 9.95043 4.70763 10.2215 4.951 10.4138C5.19436 10.606 5.49712 10.7074 5.80719 10.7005H12.3272C12.6306 10.7 12.9248 10.596 13.1612 10.4057C13.3976 10.2154 13.5619 9.95021 13.6272 9.65385L14.7272 4.70052H3.41385',
                                            'stroke': 'currentColor',
                                            'strokeLinecap': 'round',
                                            'strokeLinejoin': 'round'
                                        })), _createElement('defs', {}, _createElement('clipPath', { 'id': 'clip0_3628_301440' }, _createElement('rect', {
                                            'width': '16',
                                            'height': '16',
                                            'fill': 'white'
                                        }))))]), _createElement('div', { 'className': 'loading-overlay__spinner hidden' }, [_createElement('svg', {
                                            'aria-hidden': 'true',
                                            'focusable': 'false',
                                            'className': 'spinner',
                                            'viewBox': '0 0 66 66',
                                            'xmlns': 'http://www.w3.org/2000/svg',
                                            'key': '88020'
                                        }, _createElement('circle', {
                                            'className': 'path',
                                            'fill': 'none',
                                            'strokeWidth': '6',
                                            'cx': '33',
                                            'cy': '33',
                                            'r': '30'
                                        }))]))), _createElement('input', {
                                        'type': 'hidden',
                                        'name': 'product-id',
                                        'value': this.id
                                    }), _createElement('input', {
                                        'type': 'hidden',
                                        'name': 'section-id',
                                        'value': 'cm_results__product-grid'
                                    })))] : null, this.show_b2b_add_to_cart ? [
                                    _createElement('convermax-modal-opener', {
                                        'data-modal': '#QuickAdd-' + this.id + '-all-mb',
                                        'key': '93621'
                                    }, _createElement('button', {
                                        'id': 'quick-add-cm_results__product-grid' + this.id + '-submit',
                                        'type': 'submit',
                                        'name': 'add',
                                        'className': 'quick-add__submit button button--full-width button--secondary',
                                        'aria-haspopup': 'dialog',
                                        'aria-labelledby': 'quick-add-cm_results__product-grid' + this.id + '-submit cm_results__product-grid-' + this.id,
                                        'data-product-url': this.url + '?view=function_quickadd'
                                    }, _createElement('span', { 'className': 'icon-quick-add' }, [_createElement('svg', {
                                            'xmlns': 'http://www.w3.org/2000/svg',
                                            'width': '16',
                                            'height': '16',
                                            'viewBox': '0 0 16 16',
                                            'fill': 'none',
                                            'key': '99040'
                                        }, _createElement('g', { 'clipPath': 'url(#clip0_3628_301440)' }, _createElement('path', {
                                            'd': 'M5.33073 14.6673C5.69892 14.6673 5.9974 14.3688 5.9974 14.0007C5.9974 13.6325 5.69892 13.334 5.33073 13.334C4.96254 13.334 4.66406 13.6325 4.66406 14.0007C4.66406 14.3688 4.96254 14.6673 5.33073 14.6673Z',
                                            'stroke': 'black',
                                            'strokeLinecap': 'round',
                                            'strokeLinejoin': 'round'
                                        }), _createElement('path', {
                                            'd': 'M12.6667 14.6673C13.0349 14.6673 13.3333 14.3688 13.3333 14.0007C13.3333 13.6325 13.0349 13.334 12.6667 13.334C12.2985 13.334 12 13.6325 12 14.0007C12 14.3688 12.2985 14.6673 12.6667 14.6673Z',
                                            'stroke': 'black',
                                            'strokeLinecap': 'round',
                                            'strokeLinejoin': 'round'
                                        }), _createElement('path', {
                                            'd': 'M1.36719 1.36719H2.70052L4.47385 9.64719C4.53891 9.95043 4.70763 10.2215 4.951 10.4138C5.19436 10.606 5.49712 10.7074 5.80719 10.7005H12.3272C12.6306 10.7 12.9248 10.596 13.1612 10.4057C13.3976 10.2154 13.5619 9.95021 13.6272 9.65385L14.7272 4.70052H3.41385',
                                            'stroke': 'black',
                                            'strokeLinecap': 'round',
                                            'strokeLinejoin': 'round'
                                        })), _createElement('defs', {}, _createElement('clipPath', { 'id': 'clip0_3628_301440' }, _createElement('rect', {
                                            'width': '16',
                                            'height': '16',
                                            'fill': 'white'
                                        }))))]), _createElement('div', { 'className': 'loading-overlay__spinner hidden' }, [_createElement('svg', {
                                            'aria-hidden': 'true',
                                            'focusable': 'false',
                                            'className': 'spinner',
                                            'viewBox': '0 0 66 66',
                                            'xmlns': 'http://www.w3.org/2000/svg',
                                            'key': '111900'
                                        }, _createElement('circle', {
                                            'className': 'path',
                                            'fill': 'none',
                                            'strokeWidth': '6',
                                            'cx': '33',
                                            'cy': '33',
                                            'r': '30'
                                        }))]))),
                                    _createElement('convermax-quick-add-modal', {
                                        'id': 'QuickAdd-' + this.id + '-all-mb',
                                        'key': '93623',
                                        'class': 'quick-add-modal quick-add-modal_all'
                                    }, _createElement('div', {
                                        'role': 'dialog',
                                        'aria-label': this.removeHTML(this.title),
                                        'aria-modal': 'true',
                                        'className': 'quick-add-modal__content global-settings-popup',
                                        'tabIndex': '-1'
                                    }, _createElement('button', {
                                        'id': 'ModalClose-' + this.id,
                                        'type': 'button',
                                        'className': 'quick-add-modal__toggle'
                                    }, [_createElement('svg', {
                                            'xmlns': 'http://www.w3.org/2000/svg',
                                            'aria-hidden': 'true',
                                            'focusable': 'false',
                                            'className': 'icon icon-close',
                                            'fill': 'none',
                                            'viewBox': '0 0 18 17',
                                            'key': '118920'
                                        }, _createElement('path', {
                                            'd': 'M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z',
                                            'fill': 'currentColor'
                                        }))]), _createElement('div', {
                                        'id': 'QuickAddInfo-' + this.id,
                                        'className': 'quick-add-modal__content-info rocket-main-product'
                                    })))
                                ] : null) : null), _createElement('div', { 'className': 'card__wishlist' }, _createElement('button', {
                                    'aria-label': 'Add to Wishlist',
                                    'data-with-epi': 'true',
                                    'className': 'swym-button swym-add-to-wishlist-view-product product_' + this.id,
                                    'data-product-swatch-id': this.id,
                                    'data-swaction': 'addToWishlist',
                                    'data-product-id': this.id,
                                    'data-variant-id': this.variant_ids[0],
                                    'data-product-url': this.url
                                }, [_createElement('svg', {
                                        'xmlns': 'http://www.w3.org/2000/svg',
                                        'width': '22',
                                        'height': '22',
                                        'viewBox': '0 0 22 22',
                                        'fill': 'none',
                                        'key': '128940'
                                    }, _createElement('path', {
                                        'd': 'M16.2137 12.7074C17.387 11.5719 18.5762 10.2107 18.5762 8.42963C18.5762 7.2951 18.1198 6.20703 17.3076 5.40479C16.4953 4.60255 15.3936 4.15186 14.2449 4.15186C12.8589 4.15186 11.8824 4.54074 10.7012 5.70741C9.51992 4.54074 8.54342 4.15186 7.15742 4.15186C6.0087 4.15186 4.90703 4.60255 4.09477 5.40479C3.2825 6.20703 2.82617 7.2951 2.82617 8.42963C2.82617 10.2185 4.00742 11.5796 5.18867 12.7074L10.7012 18.1519L16.2137 12.7074Z',
                                        'stroke': 'black',
                                        'strokeLinecap': 'round',
                                        'strokeLinejoin': 'round'
                                    }))]))), _createElement('div', { 'className': 'card__vendor card__vendor--desk' }, _createElement('div', { 'className': 'card_vendor--image' }, this.vendor_image ? [_createElement('img', {
                                        'src': this.vendor_image,
                                        'onError': this.onImageError,
                                        'alt': this.removeHTML(this.vendor),
                                        'loading': 'lazy',
                                        'className': 'product-desc-image',
                                        'key': '136651'
                                    })] : null, !this.vendor_image ? [_createElement('span', { 'key': '138771' }, this.vendor)] : null)), _createElement('div', { 'className': 'card__content card__content--bottom' }, _createElement('div', { 'className': 'card__information' }, _createElement('div', { 'className': 'card__information-wrapper' }, _createElement('div', { 'className': 'card__top--infor' }, _createElement('div', { 'className': 'card__vendor' }, this.vendor_image ? [_createElement('img', {
                                        'src': this.vendor_image,
                                        'onError': this.onImageError,
                                        'alt': this.removeHTML(this.vendor),
                                        'loading': 'lazy',
                                        'className': 'product-desc-image',
                                        'key': '142341'
                                    })] : null, !this.vendor_image ? [_createElement('span', { 'key': '144581' }, this.vendor)] : null), _createElement('div', { 'className': 'card__sku' }, _createElement('span', {}, 'Sku:'), _createElement('span', { dangerouslySetInnerHTML: { __html: typeof this.sku === 'undefined' ? '' : this.sku } }))), _createElement('h3', {
                                    'className': 'card__heading h5',
                                    'id': 'cm_results__product-grid-' + this.id
                                }, _createElement('a', mergeProps({
                                    'href': this.url,
                                    'id': 'CardLink-cm_results__product-grid-' + this.id,
                                    'className': 'card-link',
                                    'aria-labelledby': 'CardLink-cm_results__product-grid-' + this.id + ' Badge-cm_results__product-grid-' + this.id
                                }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } }))), _createElement('div', { 'className': 'card-information__bottom' }, [this.review_count ? _createElement.apply(this, [
                                        'div',
                                        {
                                            'className': 'cm_review-stars',
                                            'key': '153390'
                                        },
                                        _map([
                                            0,
                                            1,
                                            2,
                                            3,
                                            4
                                        ], repeatI3.bind(this)),
                                        _createElement('span', { 'className': 'cm_review-count' }, '(', this.review_count, ')')
                                    ]) : null], _createElement('span', { 'className': 'caption-large light' }), scopeDiscount4.apply(this, []))), _createElement('div', { 'className': 'card__content--status' }, _createElement('div', { 'className': 'card__sku card__sku-desktop' }, _createElement('span', {}, 'Sku:'), _createElement('span', { dangerouslySetInnerHTML: { __html: typeof this.sku === 'undefined' ? '' : this.sku } })), _createElement('div', { 'className': 'card-info-status__product' }, this.rocket_procduct_pendiente ? [
                                    _createElement('span', {
                                        'className': 'icon',
                                        'key': '174771'
                                    }, [_createElement('svg', {
                                            'xmlns': 'http://www.w3.org/2000/svg',
                                            'width': '14',
                                            'height': '14',
                                            'viewBox': '0 0 14 14',
                                            'fill': 'none',
                                            'key': '175790'
                                        }, _createElement('path', {
                                            'd': 'M7 3.5V7L9.33333 8.16667',
                                            'stroke': '#ECB621',
                                            'strokeWidth': '1.5',
                                            'strokeLinecap': 'round',
                                            'strokeLinejoin': 'round'
                                        }), _createElement('path', {
                                            'd': 'M9.33261 12.3429C8.28411 12.801 7.12405 12.9405 5.99683 12.7443C4.8696 12.548 3.82499 12.0246 2.99298 11.2391C2.16098 10.4537 1.57834 9.44092 1.31758 8.32685C1.05681 7.21278 1.12944 6.04662 1.52642 4.97351C1.92339 3.9004 2.62719 2.96773 3.55022 2.29158C4.47324 1.61543 5.57473 1.22566 6.7176 1.17078C7.86046 1.1159 8.99423 1.39833 9.9778 1.98292C10.9614 2.56751 11.7513 3.42845 12.2493 4.45858',
                                            'stroke': '#ECB621',
                                            'strokeWidth': '1.5',
                                            'strokeLinecap': 'round',
                                            'strokeLinejoin': 'round'
                                        }), _createElement('path', {
                                            'd': 'M11.6641 6.70801V10.208',
                                            'stroke': '#ECB621',
                                            'strokeWidth': '1.5',
                                            'strokeLinecap': 'round',
                                            'strokeLinejoin': 'round'
                                        }), _createElement('path', {
                                            'd': 'M11.6641 12.542H11.6707',
                                            'stroke': '#ECB621',
                                            'strokeWidth': '1.5',
                                            'strokeLinecap': 'round',
                                            'strokeLinejoin': 'round'
                                        }))]),
                                    _createElement('span', {
                                        'className': 'text',
                                        'key': '174773'
                                    }, _translate(`product_stock_pending`))
                                ] : null, !this.rocket_procduct_pendiente ? [
                                    !this.out_of_stock ? [
                                        _createElement('span', {
                                            'className': 'icon',
                                            'key': '187571'
                                        }, [_createElement('svg', {
                                                'xmlns': 'http://www.w3.org/2000/svg',
                                                'width': '16',
                                                'height': '16',
                                                'viewBox': '0 0 16 16',
                                                'fill': 'none',
                                                'key': '188510'
                                            }, _createElement('path', {
                                                'd': 'M13.3008 4.5498L6.42578 11.4248L3.30078 8.2998',
                                                'stroke': '#0CB73F',
                                                'strokeWidth': '1.5',
                                                'strokeLinecap': 'round',
                                                'strokeLinejoin': 'round'
                                            }))]),
                                        _createElement('span', {
                                            'className': 'text',
                                            'key': '187573'
                                        }, _translate(`product_stock_available`))
                                    ] : null,
                                    this.out_of_stock ? [
                                        _createElement('span', {
                                            'className': 'icon',
                                            'key': '192701'
                                        }, [_createElement('svg', {
                                                'xmlns': 'http://www.w3.org/2000/svg',
                                                'width': '14',
                                                'height': '14',
                                                'viewBox': '0 0 14 14',
                                                'fill': 'none',
                                                'key': '193630'
                                            }, _createElement('path', {
                                                'd': 'M10.5 3.5L3.5 10.5',
                                                'stroke': '#EF4A4A',
                                                'strokeWidth': '1.5',
                                                'strokeLinecap': 'round',
                                                'strokeLinejoin': 'round'
                                            }), _createElement('path', {
                                                'd': 'M3.5 3.5L10.5 10.5',
                                                'stroke': '#EF4A4A',
                                                'strokeWidth': '1.5',
                                                'strokeLinecap': 'round',
                                                'strokeLinejoin': 'round'
                                            }))]),
                                        _createElement('span', {
                                            'className': 'text',
                                            'key': '192703'
                                        }, _translate(`product_out_of_stock`))
                                    ] : null
                                ] : null), this.variant_ids?.length > 1 ? _createElement('div', {
                                    'className': 'card-info-status__color',
                                    'key': '19903'
                                }, _createElement('a', { 'href': this.url }, _createElement('span', { 'className': 'text' }, '+ ', _translate(`product_options`)))) : null)), _createElement('div', { 'className': 'card__feature' }, _createElement('div', { 'className': 'quick-view' }, _createElement('convermax-modal-opener', { 'data-modal': '#QuickView-' + this.id + '-pc' }, _createElement('button', {
                                    'id': 'quick-view-cm_results__product-grid' + this.id + '-submit-qv',
                                    'type': 'submit',
                                    'name': 'addQuickView',
                                    'className': 'quick-view__submit button',
                                    'aria-haspopup': 'dialog',
                                    'aria-labelledby': 'quick-view-cm_results__product-grid' + this.id + '-submit-qv title-cm_results__product-grid-' + this.id + '-qv',
                                    'data-product-url': this.url + '?view=function_quickview'
                                }, _createElement('span', { 'className': 'icon-quick-view' }, [_createElement('svg', {
                                        'xmlns': 'http://www.w3.org/2000/svg',
                                        'width': '24',
                                        'height': '24',
                                        'viewBox': '0 0 24 24',
                                        'fill': 'none',
                                        'key': '206950'
                                    }, _createElement('path', {
                                        'd': 'M2.06251 12.3474C1.97916 12.1229 1.97916 11.8759 2.06251 11.6514C2.87421 9.68324 4.25202 8.00042 6.02128 6.81628C7.79053 5.63214 9.87155 5 12.0005 5C14.1295 5 16.2105 5.63214 17.9797 6.81628C19.749 8.00042 21.1268 9.68324 21.9385 11.6514C22.0218 11.8759 22.0218 12.1229 21.9385 12.3474C21.1268 14.3155 19.749 15.9983 17.9797 17.1825C16.2105 18.3666 14.1295 18.9988 12.0005 18.9988C9.87155 18.9988 7.79053 18.3666 6.02128 17.1825C4.25202 15.9983 2.87421 14.3155 2.06251 12.3474Z',
                                        'stroke': 'currentColor',
                                        'strokeWidth': '1.2',
                                        'strokeLinecap': 'round',
                                        'strokeLinejoin': 'round'
                                    }), _createElement('path', {
                                        'd': 'M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z',
                                        'stroke': 'currentColor',
                                        'strokeWidth': '1.2',
                                        'strokeLinecap': 'round',
                                        'strokeLinejoin': 'round'
                                    }))]), _createElement('div', { 'className': 'loading-overlay__spinner hidden' }, [_createElement('svg', {
                                        'aria-hidden': 'true',
                                        'focusable': 'false',
                                        'className': 'spinner',
                                        'viewBox': '0 0 66 66',
                                        'xmlns': 'http://www.w3.org/2000/svg',
                                        'key': '217120'
                                    }, _createElement('circle', {
                                        'className': 'path',
                                        'fill': 'none',
                                        'strokeWidth': '6',
                                        'cx': '33',
                                        'cy': '33',
                                        'r': '30'
                                    }))]))), _createElement('convermax-quick-add-modal', {
                                    'id': 'QuickView-' + this.id + '-pc',
                                    'class': 'quick-add-modal quick-view-modal quick-add-modal_all'
                                }, _createElement('div', {
                                    'role': 'dialog',
                                    'aria-label': this.removeHTML(this.title),
                                    'aria-modal': 'true',
                                    'className': 'quick-add-modal__content global-settings-popup',
                                    'tabIndex': '-1'
                                }, _createElement('button', {
                                    'id': 'ModalClose-' + this.id,
                                    'type': 'button',
                                    'className': 'quick-add-modal__toggle'
                                }, [_createElement('svg', {
                                        'xmlns': 'http://www.w3.org/2000/svg',
                                        'aria-hidden': 'true',
                                        'focusable': 'false',
                                        'className': 'icon icon-close',
                                        'fill': 'none',
                                        'viewBox': '0 0 18 17',
                                        'key': '224140'
                                    }, _createElement('path', {
                                        'd': 'M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z',
                                        'fill': 'currentColor'
                                    }))]), _createElement('div', {
                                    'id': 'QuickAddInfo-' + this.id,
                                    'className': 'quick-add-modal__content-info rocket--product-quickView rocket-main-product'
                                })))), !this.out_of_stock ? _createElement('div', {
                                    'className': 'quick-add no-js-hidden',
                                    'key': '23058'
                                }, this.variant_ids.length === 1 ? [_createElement('convermax-product-form', {
                                        'data-section-id': 'cm_results__product-grid',
                                        'key': '231321'
                                    }, _createElement('div', {
                                        'className': 'product-form__error-message-wrapper',
                                        'role': 'alert',
                                        'hidden': true
                                    }, [_createElement('svg', {
                                            'aria-hidden': 'true',
                                            'focusable': 'false',
                                            'className': 'icon icon-error cm_icon cm_icon-alert',
                                            'viewBox': '0 0 13 13',
                                            'key': '233660'
                                        }, _createElement('circle', {
                                            'cx': '6.5',
                                            'cy': '6.50049',
                                            'r': '5.5',
                                            'stroke': 'white',
                                            'strokeWidth': '2'
                                        }), _createElement('circle', {
                                            'cx': '6.5',
                                            'cy': '6.5',
                                            'r': '5.5',
                                            'fill': '#EB001B',
                                            'stroke': '#EB001B',
                                            'strokeWidth': '0.7'
                                        }), _createElement('path', {
                                            'd': 'M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z',
                                            'fill': 'white'
                                        }), _createElement('path', {
                                            'd': 'M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z',
                                            'fill': 'white',
                                            'stroke': '#EB001B',
                                            'strokeWidth': '0.7'
                                        }))], _createElement('span', { 'className': 'product-form__error-message' })), _createElement('form', {
                                        'method': 'post',
                                        'action': '/cart/add',
                                        'id': 'quick-add-cm_results__product-grid' + this.id,
                                        'acceptCharset': 'UTF-8',
                                        'className': 'form',
                                        'encType': 'multipart/form-data',
                                        'noValidate': 'novalidate',
                                        'data-type': 'add-to-cart-form'
                                    }, _createElement('input', {
                                        'type': 'hidden',
                                        'name': 'form_type',
                                        'value': 'product'
                                    }), _createElement('input', {
                                        'type': 'hidden',
                                        'name': 'utf8',
                                        'value': '\u2713'
                                    }), _createElement('input', {
                                        'type': 'hidden',
                                        'name': 'id',
                                        'value': this.variant_ids[0]
                                    }), _createElement('div', { 'className': 'quick-add__wrapper' }, _createElement('convermax-quantity-input', {
                                        'data-url': this.url,
                                        'data-section': 'cm_results__product-grid',
                                        'class': 'quantity'
                                    }, _createElement('button', {
                                        'className': 'quantity__button no-js-hidden disabled',
                                        'name': 'minus',
                                        'type': 'button'
                                    }, [_createElement('svg', {
                                            'xmlns': 'http://www.w3.org/2000/svg',
                                            'aria-hidden': 'true',
                                            'focusable': 'false',
                                            'className': 'icon icon-minus',
                                            'fill': 'none',
                                            'viewBox': '0 0 10 2',
                                            'key': '252150'
                                        }, _createElement('path', {
                                            'fillRule': 'evenodd',
                                            'clipRule': 'evenodd',
                                            'd': 'M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z',
                                            'fill': 'currentColor'
                                        }))]), _createElement('input', {
                                        'className': 'quantity__input',
                                        'type': 'number',
                                        'name': 'quantity',
                                        'id': 'Quantity-cm_results__product-grid',
                                        'data-cart-quantity': true,
                                        'data-min': '1',
                                        'min': '1',
                                        'step': '1',
                                        'value': '1',
                                        'defaultValue': '1',
                                        'form': 'quick-add-cm_results__product-grid' + this.id
                                    }), _createElement('button', {
                                        'className': 'quantity__button no-js-hidden',
                                        'name': 'plus',
                                        'type': 'button'
                                    }, [_createElement('svg', {
                                            'xmlns': 'http://www.w3.org/2000/svg',
                                            'aria-hidden': 'true',
                                            'focusable': 'false',
                                            'className': 'icon icon-plus',
                                            'fill': 'none',
                                            'viewBox': '0 0 10 10',
                                            'key': '259020'
                                        }, _createElement('path', {
                                            'fillRule': 'evenodd',
                                            'clipRule': 'evenodd',
                                            'd': 'M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z',
                                            'fill': 'currentColor'
                                        }))])), _createElement('button', {
                                        'id': 'quick-add-cm_results__product-grid' + this.id + '-submit',
                                        'type': 'submit',
                                        'name': 'add',
                                        'className': 'quick-add__submit button button--full-width button--secondary',
                                        'aria-haspopup': 'dialog',
                                        'aria-labelledby': 'quick-add-cm_results__product-grid' + this.id + '-submit cm_results__product-grid-' + this.id,
                                        'aria-live': 'polite',
                                        'data-sold-out-message': 'true'
                                    }, _createElement('span', { 'className': 'icon-quick-add' }, [_createElement('svg', {
                                            'xmlns': 'http://www.w3.org/2000/svg',
                                            'width': '16',
                                            'height': '16',
                                            'viewBox': '0 0 16 16',
                                            'fill': 'none',
                                            'key': '267600'
                                        }, _createElement('g', { 'clip-path': 'url(#clip0_3628_301440)' }, _createElement('path', {
                                            'd': 'M5.33073 14.6673C5.69892 14.6673 5.9974 14.3688 5.9974 14.0007C5.9974 13.6325 5.69892 13.334 5.33073 13.334C4.96254 13.334 4.66406 13.6325 4.66406 14.0007C4.66406 14.3688 4.96254 14.6673 5.33073 14.6673Z',
                                            'stroke': 'currentColor',
                                            'strokeLinecap': 'round',
                                            'strokeLinejoin': 'round'
                                        }), _createElement('path', {
                                            'd': 'M12.6667 14.6673C13.0349 14.6673 13.3333 14.3688 13.3333 14.0007C13.3333 13.6325 13.0349 13.334 12.6667 13.334C12.2985 13.334 12 13.6325 12 14.0007C12 14.3688 12.2985 14.6673 12.6667 14.6673Z',
                                            'stroke': 'currentColor',
                                            'strokeLinecap': 'round',
                                            'strokeLinejoin': 'round'
                                        }), _createElement('path', {
                                            'd': 'M1.36719 1.36719H2.70052L4.47385 9.64719C4.53891 9.95043 4.70763 10.2215 4.951 10.4138C5.19436 10.606 5.49712 10.7074 5.80719 10.7005H12.3272C12.6306 10.7 12.9248 10.596 13.1612 10.4057C13.3976 10.2154 13.5619 9.95021 13.6272 9.65385L14.7272 4.70052H3.41385',
                                            'stroke': 'currentColor',
                                            'strokeLinecap': 'round',
                                            'strokeLinejoin': 'round'
                                        })), _createElement('defs', {}, _createElement('clipPath', { 'id': 'clip0_3628_301440' }, _createElement('rect', {
                                            'width': '16',
                                            'height': '16',
                                            'fill': 'white'
                                        }))))]), _createElement('div', { 'className': 'loading-overlay__spinner hidden' }, [_createElement('svg', {
                                            'aria-hidden': 'true',
                                            'focusable': 'false',
                                            'className': 'spinner',
                                            'viewBox': '0 0 66 66',
                                            'xmlns': 'http://www.w3.org/2000/svg',
                                            'key': '280800'
                                        }, _createElement('circle', {
                                            'className': 'path',
                                            'fill': 'none',
                                            'strokeWidth': '6',
                                            'cx': '33',
                                            'cy': '33',
                                            'r': '30'
                                        }))]))), _createElement('input', {
                                        'type': 'hidden',
                                        'name': 'product-id',
                                        'value': this.id
                                    }), _createElement('input', {
                                        'type': 'hidden',
                                        'name': 'section-id',
                                        'value': 'cm_results__product-grid'
                                    })))] : null, this.show_b2b_add_to_cart ? [
                                    _createElement('convermax-modal-opener', {
                                        'data-modal': '#QuickAdd-' + this.id + '-all-pc',
                                        'key': '286401'
                                    }, _createElement('button', {
                                        'id': 'cm_results__product-grid' + this.id + '-submit',
                                        'type': 'submit',
                                        'name': 'add',
                                        'className': 'quick-add__submit button button--full-width button--secondary',
                                        'aria-haspopup': 'dialog',
                                        'aria-labelledby': 'cm_results__product-grid' + this.id + '-submit cm_results__product-grid-' + this.id,
                                        'data-product-url': this.url + '?view=function_quickadd'
                                    }, _createElement('span', { 'className': 'icon-quick-add' }, [_createElement('svg', {
                                            'xmlns': 'http://www.w3.org/2000/svg',
                                            'width': '16',
                                            'height': '16',
                                            'viewBox': '0 0 16 16',
                                            'fill': 'none',
                                            'key': '291620'
                                        }, _createElement('g', { 'clip-path': 'url(#clip0_3628_301440)' }, _createElement('path', {
                                            'd': 'M5.33073 14.6673C5.69892 14.6673 5.9974 14.3688 5.9974 14.0007C5.9974 13.6325 5.69892 13.334 5.33073 13.334C4.96254 13.334 4.66406 13.6325 4.66406 14.0007C4.66406 14.3688 4.96254 14.6673 5.33073 14.6673Z',
                                            'stroke': 'currentColor',
                                            'strokeLinecap': 'round',
                                            'strokeLinejoin': 'round'
                                        }), _createElement('path', {
                                            'd': 'M12.6667 14.6673C13.0349 14.6673 13.3333 14.3688 13.3333 14.0007C13.3333 13.6325 13.0349 13.334 12.6667 13.334C12.2985 13.334 12 13.6325 12 14.0007C12 14.3688 12.2985 14.6673 12.6667 14.6673Z',
                                            'stroke': 'currentColor',
                                            'strokeLinecap': 'round',
                                            'strokeLinejoin': 'round'
                                        }), _createElement('path', {
                                            'd': 'M1.36719 1.36719H2.70052L4.47385 9.64719C4.53891 9.95043 4.70763 10.2215 4.951 10.4138C5.19436 10.606 5.49712 10.7074 5.80719 10.7005H12.3272C12.6306 10.7 12.9248 10.596 13.1612 10.4057C13.3976 10.2154 13.5619 9.95021 13.6272 9.65385L14.7272 4.70052H3.41385',
                                            'stroke': 'currentColor',
                                            'strokeLinecap': 'round',
                                            'strokeLinejoin': 'round'
                                        })), _createElement('defs', {}, _createElement('clipPath', { 'id': 'clip0_3628_301440' }, _createElement('rect', {
                                            'width': '16',
                                            'height': '16',
                                            'fill': 'white'
                                        }))))]), _createElement('div', { 'className': 'loading-overlay__spinner hidden' }, [_createElement('svg', {
                                            'aria-hidden': 'true',
                                            'focusable': 'false',
                                            'className': 'spinner',
                                            'viewBox': '0 0 66 66',
                                            'xmlns': 'http://www.w3.org/2000/svg',
                                            'key': '304700'
                                        }, _createElement('circle', {
                                            'className': 'path',
                                            'fill': 'none',
                                            'strokeWidth': '6',
                                            'cx': '33',
                                            'cy': '33',
                                            'r': '30'
                                        }))]))),
                                    _createElement('convermax-quick-add-modal', {
                                        'id': 'QuickAdd-' + this.id + '-all-pc',
                                        'key': '286403',
                                        'class': 'quick-add-modal quick-add-modal_all'
                                    }, _createElement('div', {
                                        'role': 'dialog',
                                        'aria-modal': 'true',
                                        'className': 'quick-add-modal__content global-settings-popup',
                                        'tabIndex': '-1'
                                    }, _createElement('button', {
                                        'id': 'ModalClose-' + this.id,
                                        'type': 'button',
                                        'className': 'quick-add-modal__toggle',
                                        'aria-label': 'Close'
                                    }, [_createElement('svg', {
                                            'xmlns': 'http://www.w3.org/2000/svg',
                                            'aria-hidden': 'true',
                                            'focusable': 'false',
                                            'className': 'icon icon-close',
                                            'fill': 'none',
                                            'viewBox': '0 0 18 17',
                                            'key': '311480'
                                        }, _createElement('path', {
                                            'd': 'M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z',
                                            'fill': 'currentColor'
                                        }))]), _createElement('div', {
                                        'id': 'QuickAddInfo-' + this.id,
                                        'className': 'quick-add-modal__content-info rocket-main-product'
                                    })))
                                ] : null) : null))))] : null, this.is_promotional_item ? [_createElement('a', {
                                    'href': this.url,
                                    'className': 'collection-banner__text-link',
                                    'key': '318520'
                                }, _createElement('div', { 'className': 'collection-banner' }, _createElement('div', { 'className': 'collection-banner__img collection-banner__img--desktop' }, _createElement('img', {
                                    'src': this.imageOrDefault(this.image),
                                    'alt': this.image_alt || this.title,
                                    'onError': this.onImageError,
                                    'loading': 'lazy',
                                    'className': 'metafield-file_reference'
                                })), _createElement('div', { 'className': 'collection-banner__img collection-banner__img--mobile' }, _createElement('img', {
                                    'src': this.imageOrDefault(this.image),
                                    'alt': this.image_alt || this.title,
                                    'onError': this.onImageError,
                                    'loading': 'lazy',
                                    'className': 'metafield-file_reference'
                                })), _createElement('div', { 'className': 'collection-banner__content collection-banner__content-align-left collection-banner__content--bottom' }, _createElement('div', { 'className': 'collection-banner__align' }, _createElement('h2', { 'className': 'collection-banner__title' }, this.title), _createElement('span', { 'className': 'collection-banner__btn' }, this.button_text)))))] : null);
                        }, { count: undefined })];
                }
                return _createElement('div', { 'className': 'product-grid-container collection' + (isB2B ? ' cm_SearchResult__b2b' : ' cm_SearchResult__b2c') + ' cm_SearchResult' }, !isB2B ? _createElement.apply(this, [
                    'ul',
                    {
                        'className': 'grid product-grid grid--2-col-tablet-down grid--5-col-desktop' + (this.view ? ` ${ this.view }` : '') + ' cmRepeater_items',
                        'key': '147'
                    },
                    _map(this.items, repeatItems1.bind(this))
                ]) : null, isB2B ? _createElement.apply(this, [
                    'ul',
                    {
                        'className': 'grid product-grid grid--2-col-tablet-down grid--5-col-desktop' + (this.view ? ` ${ this.view }` : '') + ' cmRepeater_items',
                        'key': '23995'
                    },
                    _map(this.items, repeatItems2.bind(this))
                ]) : null, [this.message(function () {
                        function scopeUsageLimit1() {
                            var usageLimit = this.usageLimitExceeded();
                            return [usageLimit ? [_createElement('div', {
                                        'className': 'cm_message__usage-limit-exceeded',
                                        'key': '900'
                                    }, '\n  ', _translate(`message_usage_limit_exceeded_header`, {  providerName: usageLimit.providerName  }), '\n  ', _createElement('p', {}, _translate(`message_usage_limit_exceeded_footer`, {  providerName: usageLimit.providerName  })))] : null];
                        }
                        return _createElement('div', { 'className': 'cm_message' }, scopeUsageLimit1.apply(this, []), this.demoPlanActive ? [_createElement('div', { 'key': '4060' }, '\n  Your store is currently running Convermax Search on a demo plan. The only limitation is that some product\n  images are replaced with a picture of a goose. Please upgrade your plan to remove this restriction.\n')] : null, this.trialExpired ? [_createElement('div', { 'key': '6830' }, _createElement('h2', { 'className': 'cm_message-header' }, 'YMM Search trial period has expired.'), '\n  Product information, including pricing and fitments, is outdated. This store runs on a limited trial version\n  of Convermax Year Make Model fitment search. Please contact\n  ', _createElement('a', {
                                'href': 'mailto:support@convermax.com',
                                'className': 'cm_message-link'
                            }, 'support@convermax.com'), ' to complete setup\n  or cancel the integration.\n')] : null, this.aggressiveWheels ? [_createElement('div', { 'key': '11330' }, _translate(`message_aggressive_wheels`, {  vehicleString : this. vehicleString  }))] : null, this.incompatibleParts ? [_createElement('div', {
                                'className': 'cm_message__incompatible',
                                'key': '12620'
                            }, _createElement('div', {}, _translate(`message_incompatible_text_results`, {  vehicleString : this. vehicleString  })))] : null, this.nonVehicleSpecificResults ? [_createElement('div', {
                                'className': 'cm_message__nothing-for-vehicle',
                                'key': '14490'
                            }, '\n  ', _translate(`message_non_vehicle_specific_results`, {  vehicleString : this. vehicleString  }), '\n  ', _createElement('a', {
                                'tabIndex': '0',
                                'className': 'cm_message-link',
                                'href': this.searchByVehicleUrl
                            }, _translate(`message_view_compatible_products`)))] : null, this.universalFitResults ? [_createElement('div', {
                                'className': 'cm_message__universal-results',
                                'key': '17720'
                            }, _translate(`message_universal_fit_results`))] : null, this.template === 'badRequest' ? _createElement('div', {
                            'className': 'cmTemplate_badRequest',
                            'key': '1927'
                        }, _createElement('div', {}, '\n  ', _translate(`message_search_failed`), '\n  ', _createElement('a', {
                            'tabIndex': '0',
                            'className': 'cm_message-link',
                            'onClick': this.startOver
                        }, _translate(`message_reset_search`)), _createElement('br', {}), this.error ? [
                            '\n    (',
                            this.error.status ? [
                                _createElement('b', { 'key': '22160' }, 'status:'),
                                ' ',
                                this.error.status,
                                ', '
                            ] : null,
                            this.error.userId ? [
                                _createElement('b', { 'key': '23030' }, 'id:'),
                                ' ',
                                this.error.userId,
                                ', '
                            ] : null,
                            this.error.timestamp ? [
                                _createElement('b', { 'key': '23860' }, 'timestamp:'),
                                ' ',
                                this.error.timestamp,
                                ', '
                            ] : null,
                            _createElement('b', { 'key': '21794' }, 'instance:'),
                            ' ',
                            this.error.instance,
                            ')'
                        ] : null)) : null, this.template === 'corrected' ? _createElement('div', {
                            'className': 'cmTemplate_corrected',
                            'key': '2549'
                        }, _createElement('div', {}, _translate(`message_query_corrected`, { 
                            originalQuery: this.
                            originalQuery, 
                            query
                        : this.
                            query
                         }))) : null, this.template === 'networkError' ? _createElement('div', {
                            'className': 'cmTemplate_networkError',
                            'key': '2716'
                        }, _createElement('div', {}, '\n  ', _translate(`message_network_error`), '\n  ', _createElement('br', {}), this.error ? [
                            '\n    (',
                            this.error.status ? [
                                _createElement('b', { 'key': '28980' }, 'status:'),
                                ' ',
                                this.error.status,
                                ', '
                            ] : null,
                            this.error.userId ? [
                                _createElement('b', { 'key': '29850' }, 'id:'),
                                ' ',
                                this.error.userId,
                                ', '
                            ] : null,
                            this.error.timestamp ? [
                                _createElement('b', { 'key': '30680' }, 'timestamp:'),
                                ' ',
                                this.error.timestamp,
                                ', '
                            ] : null,
                            _createElement('b', { 'key': '28614' }, 'instance:'),
                            ' ',
                            this.error.instance,
                            ')'
                        ] : null)) : null, this.template === 'nothing' ? _createElement('div', {
                            'className': 'cmTemplate_nothing',
                            'key': '3231'
                        }, _createElement('div', {}, '\n  ', _translate(`message_no_results`), '\n  ', this.query || this.isFacetsSelected || this.isSearchedByVehicle ? _createElement('a', {
                            'tabIndex': '0',
                            'className': 'cm_message-link',
                            'onClick': this.startOver,
                            'key': '3355'
                        }, _translate(`message_reset_search`)) : null)) : null, this.template === 'partial' ? _createElement('div', {
                            'className': 'cmTemplate_partial',
                            'key': '3550'
                        }, _createElement('div', {}, _translate(`message_query_partial`, {  originalQuery : this. originalQuery  }))) : null, this.template === 'timeout' ? _createElement('div', {
                            'className': 'cmTemplate_timeout',
                            'key': '3704'
                        }, _createElement('div', {}, '\n  ', _translate(`message_timeout`), '\n  ', _createElement('a', {
                            'tabIndex': '0',
                            'className': 'cm_message-link',
                            'onClick': this.retry
                        }, _translate(`message_retry_search`)))) : null, this.template === 'unknown' ? _createElement('div', {
                            'className': 'cmTemplate_unknown',
                            'key': '3944'
                        }, _createElement('div', {}, '\n  ', _translate(`message_search_failed`), '\n  ', _createElement('a', {
                            'tabIndex': '0',
                            'className': 'cm_message-link',
                            'onClick': this.retry
                        }, _translate(`message_retry_search`)), _createElement('br', {}), this.error ? [
                            '\n    (',
                            this.error.status ? [
                                _createElement('b', { 'key': '42230' }, 'status:'),
                                ' ',
                                this.error.status,
                                ', '
                            ] : null,
                            this.error.userId ? [
                                _createElement('b', { 'key': '43100' }, 'id:'),
                                ' ',
                                this.error.userId,
                                ', '
                            ] : null,
                            this.error.timestamp ? [
                                _createElement('b', { 'key': '43930' }, 'timestamp:'),
                                ' ',
                                this.error.timestamp,
                                ', '
                            ] : null,
                            _createElement('b', { 'key': '41864' }, 'instance:'),
                            ' ',
                            this.error.instance,
                            ')'
                        ] : null)) : null);
                    }, {
                        widgetName: 'undefined',
                        items: undefined
                    })], [this.pagination(function () {
                        function repeatButtons1(buttons, buttonsIndex) {
                            return [buttons(function () {
                                    return this.template === 'prev' ? _createElement('li', { 'className': 'cmTemplate_prev' }, _createElement('a', {
                                        'href': this.pageLink,
                                        'className': 'pagination__item pagination__item--next pagination__item-arrow link motion-reduce page-light',
                                        'aria-label': 'Go to previous page'
                                    }, [_createElement('svg', {
                                            'className': 'icon icon-caret',
                                            'width': '14',
                                            'height': '8',
                                            'viewBox': '0 0 14 8',
                                            'fill': 'none',
                                            'key': '2000'
                                        }, _createElement('path', {
                                            'd': 'M1 1L7 7L13 1',
                                            'stroke': 'currentColor',
                                            'strokeLinecap': 'round',
                                            'strokeLinejoin': 'round'
                                        }))])) : this.template === 'page' ? _createElement('li', { 'className': 'cmTemplate_page' }, !this.isActive ? _createElement('a', {
                                        'href': this.pageLink,
                                        'className': 'pagination__item',
                                        'aria-label': 'Go to page ' + this.page,
                                        'key': '33'
                                    }, '\n      ', this.page, '\n    ') : null, this.isActive ? _createElement('span', {
                                        'className': 'pagination__item pagination__item--current',
                                        'key': '175'
                                    }, this.page) : null) : this.template === 'delimiter' ? _createElement('li', { 'className': 'cmTemplate_delimiter' }, _createElement('span', { 'className': 'pagination__item pagination__item page-light' }, _translate(`pagination_delimiter_text`))) : this.template === 'next' ? _createElement('li', { 'className': 'cmTemplate_next' }, _createElement('a', {
                                        'href': this.pageLink,
                                        'className': 'pagination__item pagination__item--prev pagination__item-arrow link motion-reduce page-light',
                                        'aria-label': 'Go to next page'
                                    }, [_createElement('svg', {
                                            'className': 'icon icon-caret',
                                            'width': '14',
                                            'height': '8',
                                            'viewBox': '0 0 14 8',
                                            'fill': 'none',
                                            'key': '1960'
                                        }, _createElement('path', {
                                            'd': 'M1 1L7 7L13 1',
                                            'stroke': 'currentColor',
                                            'strokeLinecap': 'round',
                                            'strokeLinejoin': 'round'
                                        }))])) : _createElement('div', { 'className': 'cmTemplate_Unknown' }, JSON.stringify(this));
                                }, { count: undefined })];
                        }
                        return _createElement('nav', { 'className': 'pagination cm_pagination' }, _createElement.apply(this, [
                            'ul',
                            { 'className': 'cm_mobile-hide pagination__list list-unstyled cmRepeater_buttons' },
                            _map(this.buttons, repeatButtons1.bind(this))
                        ]));
                    }, {
                        widgetName: 'undefined',
                        items: undefined
                    })], [this.loadMore(function () {
                        return showLoadMore ? _createElement('div', {
                            'className': 'cm_loadMore',
                            'key': '0'
                        }, _createElement('div', { 'className': 'cm_load-more' }, this.isNotAllItemsReceived ? [
                            this.isActive ? [this.loading] : null,
                            !this.isActive ? [[this.loadMoreButton(function () {
                                        return _createElement('div', {
                                            'className': 'button cm_loadMoreButton',
                                            'onClick': this.activate
                                        }, '\n        ', window.Convermax.config?.loadMoreText || _translate(`load_more`, {  nextPageSize : this. nextPageSize  }), '\n      ');
                                    }, {
                                        widgetName: 'undefined',
                                        items: undefined
                                    })]] : null
                        ] : null)) : null;
                    }, {
                        widgetName: 'undefined',
                        items: undefined
                    })]);
            }, {
                widgetName: 'results',
                items: undefined
            })]);
    }
    return _createElement('div', { 'className': 'clear-self cm_SearchPage' }, [_createElement('div', {
            'className': 'cm_FacetPanel',
            'key': '420'
        }, _createElement('h2', {
            'className': 'facets__heading facets__heading--vertical caption-large text-body',
            'id': 'verticalTitle',
            'tabIndex': '-1'
        }, '\n    ', _translate(`facet_dialog_open_button`), '\n  '), [this.FilterSearchBox(function () {
                return _createElement('div', { 'className': 'cm_FilterSearchBox' }, _createElement('form', {
                    'className': 'cm_filter-search-box cm_search-box-root cm_search-box-root__filter',
                    'onSubmit': this.onSubmit
                }, _createElement('div', { 'className': 'cm_search-box_form-container' }, _createElement('input', {
                    'className': 'cm_filter-search-box__input  cm_searchInput',
                    'type': 'text',
                    'placeholder': window.Convermax.config?.searchBoxPlaceholderText || _translate(`search_box_placeholder`),
                    'value': this.value,
                    'onChange': this.onChange
                }), _createElement('span', { 'className': 'cm_search-box_clear-container' }, this.inputNotEmpty ? _createElement('span', {
                    'className': 'reset__button field__button cm_search-box_clear',
                    'onClick': this.clearInput,
                    'key': '473'
                }, '\n        ', _translate(`search_box_clear`), '\n      ') : null), _createElement('div', {
                    'className': 'cm_search-box_submit cm_button cm_button__primary',
                    'title': 'Search',
                    'aria-label': 'search button',
                    'data-cm-role': 'add-query'
                }, [
                    _createElement('svg', {
                        'className': 'icon icon-search cm_mobile-hide',
                        'aria-hidden': 'true',
                        'focusable': 'false',
                        'key': '8000'
                    }, _createElement('use', { 'href': '#icon-search' })),
                    _createElement('svg', {
                        'className': 'modal__toggle-open icon icon-search cm_desktop-hide',
                        'xmlns': 'http://www.w3.org/2000/svg',
                        'width': '22',
                        'height': '22',
                        'viewBox': '0 0 22 22',
                        'fill': 'none',
                        'key': '8002'
                    }, _createElement('path', {
                        'd': 'M19.2507 19.2502L14.4868 14.4863M14.4868 14.4863C15.7762 13.197 16.5005 11.4482 16.5005 9.62477C16.5005 7.80134 15.7762 6.05259 14.4868 4.76323C13.1974 3.47387 11.4487 2.74951 9.62526 2.74951C7.80183 2.74951 6.05308 3.47387 4.76372 4.76323C3.47436 6.05259 2.75 7.80134 2.75 9.62477C2.75 11.4482 3.47436 13.197 4.76372 14.4863C6.05308 15.7757 7.80183 16.5 9.62526 16.5C11.4487 16.5 13.1974 15.7757 14.4868 14.4863Z',
                        'stroke': 'currentColor',
                        'strokeLinecap': 'round',
                        'strokeLinejoin': 'round'
                    }))
                ]))));
            }, {
                widgetName: 'undefined',
                items: undefined
            })], [this.VehicleSpecs(function () {
                function repeatSelects1(selects, selectsIndex) {
                    return [selects(function () {
                            function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                                return _createElement('option', {
                                    'disabled': this.loading,
                                    'value': entry.term,
                                    'key': entry.value
                                }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                            }
                            function repeatEntry2(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                                return _createElement('option', {
                                    'disabled': this.loading,
                                    'value': entry.term,
                                    'key': entry.value
                                }, '\n          ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n        ');
                            }
                            function scopePopularEntriesUnpopularEntriesIsPopularField3() {
                                var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                                var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                                var isPopularField = popularEntries.length && unpopularEntries.length;
                                return [
                                    !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                                        'value': '',
                                        'key': 'null-option'
                                    }, '\n          ', _translate(`select_title`), ' ', this.title, '\n        ') : null,
                                    this.loading ? _createElement('option', {
                                        'key': 'loading-option',
                                        'disabled': true
                                    }, _translate(`select_loading`)) : null,
                                    isPopularField ? [
                                        _createElement('option', {
                                            'className': 'cm_option_title cm_option-popular',
                                            'disabled': true,
                                            'key': '11501'
                                        }, _translate(`ymm_bar_popular`)),
                                        _map(popularEntries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField)),
                                        _createElement('option', {
                                            'className': 'cm_option_title cm_option-unpopular',
                                            'disabled': true,
                                            'key': '11504'
                                        }, _translate(`ymm_bar_unpopular`))
                                    ] : null,
                                    _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, popularEntries, unpopularEntries, isPopularField))
                                ];
                            }
                            function scopeShowSelectedValues4() {
                                var showSelectedValues = this.selectedEntries.length;
                                return _createElement('option', {
                                    'key': '_current',
                                    'value': '_current'
                                }, showSelectedValues ? [this.selectedEntries.map(e => e.value).join(', ')] : null, !showSelectedValues ? [
                                    _translate(`select_title`),
                                    ' ',
                                    this.title
                                ] : null);
                            }
                            function repeatEntry5(entry, index) {
                                return _createElement('div', {
                                    'className': 'option' + (this.isSearchable && this.activeIndex === index || !this.isSearchable && entry.selected ? ' cm_checked' : ''),
                                    'key': entry.value,
                                    'onClick': () => this.onChange(entry.term)
                                }, this.showCheckboxes ? _createElement('input', {
                                    'type': 'checkbox',
                                    'readOnly': true,
                                    'checked': entry.selected,
                                    'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                                    'key': '3372'
                                }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                                    'className': 'cm_dropdown_hitCount',
                                    'key': '3574'
                                }, entry.hitCount) : null);
                            }
                            return _createElement('div', { 'className': this.extraClassName }, !this.isSearchable ? _createElement('div', {
                                'className': 'cm_select_toggle' + (this.useNativeDropdown ? ' cm_select_toggle__native' : '') + ' cm_toggle-dropdown',
                                'key': '39'
                            }, _createElement('select', {
                                'className': 'cm_select_inner-select ' + (this.firstSelectedTerm ? 'cm_selected' : ''),
                                'onChange': this.onChange,
                                'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                                'disabled': this.disabled,
                                'aria-label': this.title
                            }, this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, []) : null, !this.useNativeDropdown ? scopeShowSelectedValues4.apply(this, []) : null)) : null, this.isSearchable ? [[this.filterInput(function () {
                                        return _createElement('div', { 'className': 'cm_filterInput' });
                                    }, {
                                        widgetName: 'undefined',
                                        items: undefined
                                    })]] : null, !this.disabled && !this.useNativeDropdown ? _createElement.apply(this, [
                                'div',
                                {
                                    'className': 'cm_dropdown cm_select_dropdown cm_hide',
                                    'aria-label': this.title,
                                    'key': '2634'
                                },
                                !this.hideNullOption ? _createElement('div', {
                                    'className': 'option',
                                    'key': 'null-option',
                                    'onClick': () => this.onChange('')
                                }, '\n      ', _translate(`select_title`), ' ', this.title, '\n    ') : null,
                                this.loading ? _createElement('div', {
                                    'className': 'option',
                                    'key': 'null-option',
                                    'disabled': true
                                }, _translate(`select_loading`)) : null,
                                !this.loading ? _map(this.entries, repeatEntry5.bind(this)) : null
                            ]) : null);
                        }, { count: undefined })];
                }
                return _createElement('div', { 'className': 'cm_VehicleSpecs' }, this.selects.length ? _createElement('div', {
                    'className': 'cm_vehicle-widget cm_vehicle-widget__specs',
                    'key': '29'
                }, _createElement('div', { 'className': 'facetholder' }, _createElement('div', { 'className': 'facettitle' }, _translate(`vehicle_specs_title`)), _createElement('div', { 'className': 'facetbody cm_vehicle-widget_body' }, _createElement.apply(this, [
                    'div',
                    { 'className': 'cm_vehicle-widget_select-container  cmRepeater_selects' },
                    _map(this.selects, repeatSelects1.bind(this))
                ]), _createElement('div', {
                    'className': 'cm_btn cm_button cm_button__secondary cm_filter-chips_button',
                    'title': 'Reset',
                    'onClick': this.discardExtraFields
                }, '\n        ', _translate(`vehicle_specs_reset`), '\n      ')))) : null);
            }, {
                widgetName: 'undefined',
                items: undefined
            })], [this.FilterChips(function () {
                return _createElement('div', { 'className': 'cm_FilterChips' }, [this.filterChips(function () {
                        function repeatChips1(chips, chipsIndex) {
                            return [chips(function () {
                                    function repeatI1_reviewChip(i, iIndex) {
                                        return _createElement('span', {
                                            'key': `${ this.field }|${ i }`,
                                            'className': 'cm_star cm_star__' + (!(this.value - i) || this.value - i < 0.25 ? 'empty' : this.value - i < 0.75 ? 'half' : 'full')
                                        });
                                    }
                                    return this.template === 'chip' ? _createElement('div', { 'className': 'facetdiv cmTemplate_chip' }, _createElement('a', {
                                        'className': 'facetentrykey',
                                        'tabIndex': '0',
                                        'role': 'listitem'
                                    }, _createElement('span', { 'className': 'cm_chip-name' }, this.name === 'filterQuery' ? _translate(`filter_search_box_current_search`) : this.name === 'query' ? _translate(`current_query_label`) : this.name, ':'), '\n  ', this.value, '\n'), _createElement('div', { 'className': 'facetentryval' }, [_createElement('svg', {
                                            'className': 'cm_icon cm_icon-times',
                                            'height': '20px',
                                            'role': 'img',
                                            'viewBox': '0 0 22 22',
                                            'key': '3500'
                                        }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))])) : this.template === 'reviewChip' ? _createElement('div', { 'className': 'facetdiv cmTemplate_reviewChip' }, _createElement.apply(this, [
                                        'a',
                                        {
                                            'className': 'facetentrykey',
                                            'tabIndex': '0',
                                            'role': 'listitem'
                                        },
                                        _createElement('span', { 'className': 'cm_chip-name' }, this.name, ': '),
                                        _map([
                                            0,
                                            1,
                                            2,
                                            3,
                                            4
                                        ], repeatI1_reviewChip.bind(this)),
                                        this.value !== '5' ? _createElement('span', { 'key': '391' }, ' and up') : null
                                    ]), _createElement('div', { 'className': 'facetentryval' }, [_createElement('svg', {
                                            'className': 'cm_icon cm_icon-times',
                                            'height': '20px',
                                            'role': 'img',
                                            'viewBox': '0 0 22 22',
                                            'key': '4900'
                                        }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))])) : this.template === 'rangeChip' ? _createElement('div', { 'className': 'facetdiv cmTemplate_rangeChip' }, _createElement('a', {
                                        'className': 'facetentrykey',
                                        'tabIndex': '0',
                                        'role': 'listitem'
                                    }, _createElement('span', { 'className': 'cm_chip-name' }, this.name, ':'), this.finite ? [
                                        this.selectedRange[0],
                                        ' ',
                                        _translate(`ranged_facet_range_delimiter`),
                                        ' ',
                                        this.selectedRange[1]
                                    ] : null, this.toPosInf ? [
                                        this.selectedRange[0],
                                        ' ',
                                        _translate(`ranged_facet_more`)
                                    ] : null, this.toNegInf ? [
                                        this.selectedRange[1],
                                        ' ',
                                        _translate(`ranged_facet_less`)
                                    ] : null), _createElement('div', { 'className': 'facetentryval' }, [_createElement('svg', {
                                            'className': 'cm_icon cm_icon-times',
                                            'height': '20px',
                                            'role': 'img',
                                            'viewBox': '0 0 22 22',
                                            'key': '5360'
                                        }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))])) : _createElement('div', { 'className': 'cmTemplate_Unknown' }, JSON.stringify(this));
                                }, { count: undefined })];
                        }
                        return _createElement('div', { 'className': 'cm_filterChips' }, _createElement('div', { 'className': 'facetholder' }, _createElement('div', {
                            'className': 'facettitle',
                            'tabIndex': '0'
                        }, _translate(`selected_facets_label`)), _createElement('div', { 'className': 'facetbody' }, _createElement.apply(this, [
                            'div',
                            {
                                'role': 'list',
                                'className': 'cmRepeater_chips'
                            },
                            _map(this.chips, repeatChips1.bind(this))
                        ]), _createElement('div', {
                            'className': 'cm_btn cm_button cm_button__secondary cm_filter-chips_button',
                            'data-cm-role': 'start-over'
                        }, '\n        ', _translate(`selected_facets_clear`), '\n      '))));
                    }, {
                        widgetName: 'filter-chips',
                        items: undefined
                    })]);
            }, {
                widgetName: 'undefined',
                items: undefined
            })], [this.FacetBarWheels(function () {
                function repeatSelects1(facet_bar_label, selects, selectsIndex) {
                    return [selects(function () {
                            function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                                return _createElement('option', {
                                    'disabled': this.loading,
                                    'value': entry.term,
                                    'key': entry.value
                                }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                            }
                            function repeatEntry2(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                                return _createElement('option', {
                                    'disabled': this.loading,
                                    'value': entry.term,
                                    'key': entry.value
                                }, '\n          ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n        ');
                            }
                            function scopePopularEntriesUnpopularEntriesIsPopularField3() {
                                var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                                var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                                var isPopularField = popularEntries.length && unpopularEntries.length;
                                return [
                                    !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                                        'value': '',
                                        'key': 'null-option'
                                    }, '\n          ', _translate(`select_title`), ' ', this.title, '\n        ') : null,
                                    this.loading ? _createElement('option', {
                                        'key': 'loading-option',
                                        'disabled': true
                                    }, _translate(`select_loading`)) : null,
                                    isPopularField ? [
                                        _createElement('option', {
                                            'className': 'cm_option_title cm_option-popular',
                                            'disabled': true,
                                            'key': '12601'
                                        }, _translate(`ymm_bar_popular`)),
                                        _map(popularEntries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField)),
                                        _createElement('option', {
                                            'className': 'cm_option_title cm_option-unpopular',
                                            'disabled': true,
                                            'key': '12604'
                                        }, _translate(`ymm_bar_unpopular`))
                                    ] : null,
                                    _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, popularEntries, unpopularEntries, isPopularField))
                                ];
                            }
                            function scopeShowSelectedValues4() {
                                var showSelectedValues = this.selectedEntries.length;
                                return _createElement('option', {
                                    'key': '_current',
                                    'value': '_current'
                                }, showSelectedValues ? [this.selectedEntries.map(e => e.value).join(', ')] : null, !showSelectedValues ? [
                                    _translate(`select_title`),
                                    ' ',
                                    this.title
                                ] : null);
                            }
                            function repeatEntry5(entry, index) {
                                return _createElement('div', {
                                    'className': 'option' + (this.isSearchable && this.activeIndex === index || !this.isSearchable && entry.selected ? ' cm_checked' : ''),
                                    'key': entry.value,
                                    'onClick': () => this.onChange(entry.term)
                                }, this.showCheckboxes ? _createElement('input', {
                                    'type': 'checkbox',
                                    'readOnly': true,
                                    'checked': entry.selected,
                                    'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                                    'key': '3482'
                                }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                                    'className': 'cm_dropdown_hitCount',
                                    'key': '3684'
                                }, entry.hitCount) : null);
                            }
                            return _createElement('div', { 'className': 'cmTemplate_selectFacet' }, _createElement('div', { 'className': 'cm_vehicle-widget_select' }, [_createElement('div', {
                                    'className': this.extraClassName,
                                    'key': '980'
                                }, !this.isSearchable ? _createElement('div', {
                                    'className': 'cm_select_toggle' + (this.useNativeDropdown ? ' cm_select_toggle__native' : '') + ' cm_toggle-dropdown',
                                    'key': '149'
                                }, _createElement('select', {
                                    'className': 'cm_select_inner-select ' + (this.firstSelectedTerm ? 'cm_selected' : ''),
                                    'onChange': this.onChange,
                                    'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                                    'disabled': this.disabled,
                                    'aria-label': this.title
                                }, this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, []) : null, !this.useNativeDropdown ? scopeShowSelectedValues4.apply(this, []) : null)) : null, this.isSearchable ? [[this.filterInput(function () {
                                            return _createElement('div', { 'className': 'cm_filterInput' });
                                        }, {
                                            widgetName: 'undefined',
                                            items: undefined
                                        })]] : null, !this.disabled && !this.useNativeDropdown ? _createElement.apply(this, [
                                    'div',
                                    {
                                        'className': 'cm_dropdown cm_select_dropdown cm_hide',
                                        'aria-label': this.title,
                                        'key': '2744'
                                    },
                                    !this.hideNullOption ? _createElement('div', {
                                        'className': 'option',
                                        'key': 'null-option',
                                        'onClick': () => this.onChange('')
                                    }, '\n      ', _translate(`select_title`), ' ', this.title, '\n    ') : null,
                                    this.loading ? _createElement('div', {
                                        'className': 'option',
                                        'key': 'null-option',
                                        'disabled': true
                                    }, _translate(`select_loading`)) : null,
                                    !this.loading ? _map(this.entries, repeatEntry5.bind(this)) : null
                                ]) : null)]));
                        }, { count: undefined })];
                }
                function scopeFacet_bar_label2() {
                    var facet_bar_label = _translate(`wheels_panel_label`);
                    return _createElement('div', { 'className': 'cm_FacetBarWheels' }, _createElement('div', { 'className': 'cm_FacetBarWheelsTires cm_facets' }, _createElement('div', { 'className': 'cm_vehicle-widget cm_vehicle-widget__facet-bar facetholder' }, _createElement('div', { 'className': 'cm_vehicle-widget_dropdowns' }, _createElement('div', { 'className': 'cm_vehicle-widget_title facettitle' }, facet_bar_label), _createElement('div', { 'className': 'cm_vehicle-widget_body facetbody' }, _createElement.apply(this, [
                        'div',
                        { 'className': 'cm_vehicle-widget_select-container cmRepeater_facets cmRepeater_selects' },
                        _map(this.selects, repeatSelects1.bind(this, facet_bar_label))
                    ]), _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
                        'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__clear cm_button cm_button__secondary',
                        'onClick': this.discardFields,
                        'disabled': !this.hasSelection,
                        'role': 'button',
                        'tabIndex': this.hasSelection ? '0' : '-1'
                    }, [_createElement('svg', {
                            'xmlns': 'http://www.w3.org/2000/svg',
                            'className': 'cm_icon cm_icon-reset',
                            'height': '16px',
                            'viewBox': '0 0 16 16',
                            'key': '67650'
                        }, _createElement('path', { 'd': 'M2.083,9H0.062H0v5l1.481-1.361C2.932,14.673,5.311,16,8,16c4.08,0,7.446-3.054,7.938-7h-2.021 c-0.476,2.838-2.944,5-5.917,5c-2.106,0-3.96-1.086-5.03-2.729L5.441,9H2.083z' }), _createElement('path', { 'd': 'M8,0C3.92,0,0.554,3.054,0.062,7h2.021C2.559,4.162,5.027,2,8,2c2.169,0,4.07,1.151,5.124,2.876 L11,7h2h0.917h2.021H16V2l-1.432,1.432C13.123,1.357,10.72,0,8,0z' }))])))))));
                }
                return scopeFacet_bar_label2.apply(this, []);
            }, {
                widgetName: 'undefined',
                items: undefined
            })], [this.FacetBarTires(function () {
                function repeatSelects1(facet_bar_label, selects, selectsIndex) {
                    return [selects(function () {
                            function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                                return _createElement('option', {
                                    'disabled': this.loading,
                                    'value': entry.term,
                                    'key': entry.value
                                }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                            }
                            function repeatEntry2(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                                return _createElement('option', {
                                    'disabled': this.loading,
                                    'value': entry.term,
                                    'key': entry.value
                                }, '\n          ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n        ');
                            }
                            function scopePopularEntriesUnpopularEntriesIsPopularField3() {
                                var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                                var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                                var isPopularField = popularEntries.length && unpopularEntries.length;
                                return [
                                    !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                                        'value': '',
                                        'key': 'null-option'
                                    }, '\n          ', _translate(`select_title`), ' ', this.title, '\n        ') : null,
                                    this.loading ? _createElement('option', {
                                        'key': 'loading-option',
                                        'disabled': true
                                    }, _translate(`select_loading`)) : null,
                                    isPopularField ? [
                                        _createElement('option', {
                                            'className': 'cm_option_title cm_option-popular',
                                            'disabled': true,
                                            'key': '12601'
                                        }, _translate(`ymm_bar_popular`)),
                                        _map(popularEntries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField)),
                                        _createElement('option', {
                                            'className': 'cm_option_title cm_option-unpopular',
                                            'disabled': true,
                                            'key': '12604'
                                        }, _translate(`ymm_bar_unpopular`))
                                    ] : null,
                                    _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, popularEntries, unpopularEntries, isPopularField))
                                ];
                            }
                            function scopeShowSelectedValues4() {
                                var showSelectedValues = this.selectedEntries.length;
                                return _createElement('option', {
                                    'key': '_current',
                                    'value': '_current'
                                }, showSelectedValues ? [this.selectedEntries.map(e => e.value).join(', ')] : null, !showSelectedValues ? [
                                    _translate(`select_title`),
                                    ' ',
                                    this.title
                                ] : null);
                            }
                            function repeatEntry5(entry, index) {
                                return _createElement('div', {
                                    'className': 'option' + (this.isSearchable && this.activeIndex === index || !this.isSearchable && entry.selected ? ' cm_checked' : ''),
                                    'key': entry.value,
                                    'onClick': () => this.onChange(entry.term)
                                }, this.showCheckboxes ? _createElement('input', {
                                    'type': 'checkbox',
                                    'readOnly': true,
                                    'checked': entry.selected,
                                    'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                                    'key': '3482'
                                }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                                    'className': 'cm_dropdown_hitCount',
                                    'key': '3684'
                                }, entry.hitCount) : null);
                            }
                            return _createElement('div', { 'className': 'cmTemplate_selectFacet' }, _createElement('div', { 'className': 'cm_vehicle-widget_select' }, [_createElement('div', {
                                    'className': this.extraClassName,
                                    'key': '980'
                                }, !this.isSearchable ? _createElement('div', {
                                    'className': 'cm_select_toggle' + (this.useNativeDropdown ? ' cm_select_toggle__native' : '') + ' cm_toggle-dropdown',
                                    'key': '149'
                                }, _createElement('select', {
                                    'className': 'cm_select_inner-select ' + (this.firstSelectedTerm ? 'cm_selected' : ''),
                                    'onChange': this.onChange,
                                    'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                                    'disabled': this.disabled,
                                    'aria-label': this.title
                                }, this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, []) : null, !this.useNativeDropdown ? scopeShowSelectedValues4.apply(this, []) : null)) : null, this.isSearchable ? [[this.filterInput(function () {
                                            return _createElement('div', { 'className': 'cm_filterInput' });
                                        }, {
                                            widgetName: 'undefined',
                                            items: undefined
                                        })]] : null, !this.disabled && !this.useNativeDropdown ? _createElement.apply(this, [
                                    'div',
                                    {
                                        'className': 'cm_dropdown cm_select_dropdown cm_hide',
                                        'aria-label': this.title,
                                        'key': '2744'
                                    },
                                    !this.hideNullOption ? _createElement('div', {
                                        'className': 'option',
                                        'key': 'null-option',
                                        'onClick': () => this.onChange('')
                                    }, '\n      ', _translate(`select_title`), ' ', this.title, '\n    ') : null,
                                    this.loading ? _createElement('div', {
                                        'className': 'option',
                                        'key': 'null-option',
                                        'disabled': true
                                    }, _translate(`select_loading`)) : null,
                                    !this.loading ? _map(this.entries, repeatEntry5.bind(this)) : null
                                ]) : null)]));
                        }, { count: undefined })];
                }
                function scopeFacet_bar_label2() {
                    var facet_bar_label = _translate(`tires_panel_label`);
                    return _createElement('div', { 'className': 'cm_FacetBarTires' }, _createElement('div', { 'className': 'cm_FacetBarWheelsTires cm_facets' }, _createElement('div', { 'className': 'cm_vehicle-widget cm_vehicle-widget__facet-bar facetholder' }, _createElement('div', { 'className': 'cm_vehicle-widget_dropdowns' }, _createElement('div', { 'className': 'cm_vehicle-widget_title facettitle' }, facet_bar_label), _createElement('div', { 'className': 'cm_vehicle-widget_body facetbody' }, _createElement.apply(this, [
                        'div',
                        { 'className': 'cm_vehicle-widget_select-container cmRepeater_facets cmRepeater_selects' },
                        _map(this.selects, repeatSelects1.bind(this, facet_bar_label))
                    ]), _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
                        'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__clear cm_button cm_button__secondary',
                        'onClick': this.discardFields,
                        'disabled': !this.hasSelection,
                        'role': 'button',
                        'tabIndex': this.hasSelection ? '0' : '-1'
                    }, [_createElement('svg', {
                            'xmlns': 'http://www.w3.org/2000/svg',
                            'className': 'cm_icon cm_icon-reset',
                            'height': '16px',
                            'viewBox': '0 0 16 16',
                            'key': '67630'
                        }, _createElement('path', { 'd': 'M2.083,9H0.062H0v5l1.481-1.361C2.932,14.673,5.311,16,8,16c4.08,0,7.446-3.054,7.938-7h-2.021 c-0.476,2.838-2.944,5-5.917,5c-2.106,0-3.96-1.086-5.03-2.729L5.441,9H2.083z' }), _createElement('path', { 'd': 'M8,0C3.92,0,0.554,3.054,0.062,7h2.021C2.559,4.162,5.027,2,8,2c2.169,0,4.07,1.151,5.124,2.876 L11,7h2h0.917h2.021H16V2l-1.432,1.432C13.123,1.357,10.72,0,8,0z' }))])))))));
                }
                return scopeFacet_bar_label2.apply(this, []);
            }, {
                widgetName: 'undefined',
                items: undefined
            })], [this.Facets(function () {
                return _createElement('div', { 'className': 'cm_Facets' }, [this.facets(function () {
                        function repeatFacets1(facets, facetsIndex) {
                            return [facets(function () {
                                    function repeatShowAlwaysValues1(ShowAlwaysValues, ShowAlwaysValuesIndex) {
                                        return [ShowAlwaysValues(function () {
                                                return _createElement('div', { 'className': 'facetdiv ' + this.facetDivClass }, _createElement('div', { 'className': 'facet-checkbox' }, _createElement('input', {
                                                    'type': 'checkbox',
                                                    'className': 'cm_facet_checkbox',
                                                    'readOnly': true,
                                                    'checked': this.isSelected
                                                }), !this.isSelected ? [_createElement('svg', {
                                                        'className': 'cm_unchecked',
                                                        'width': '1.6rem',
                                                        'height': '1.6rem',
                                                        'viewBox': '0 0 16 16',
                                                        'aria-hidden': 'true',
                                                        'focusable': 'false',
                                                        'key': '1930'
                                                    }, _createElement('rect', {
                                                        'x': '1',
                                                        'y': '1',
                                                        'width': '14',
                                                        'height': '14',
                                                        'stroke': 'currentColor',
                                                        'fill': 'none',
                                                        'strokeWidth': '1',
                                                        'vectorEffect': 'non-scaling-stroke'
                                                    }))] : null, this.isSelected ? [_createElement('svg', {
                                                        'className': 'cm_checked icon icon-checkmark',
                                                        'aria-hidden': 'true',
                                                        'xmlns': 'http://www.w3.org/2000/svg',
                                                        'width': '22',
                                                        'height': '23',
                                                        'viewBox': '0 0 22 23',
                                                        'fill': 'none',
                                                        'key': '5030'
                                                    }, _createElement('path', {
                                                        'd': 'M18.3327 5.82227L8.24935 15.9056L3.66602 11.3223',
                                                        'stroke': 'white',
                                                        'strokeWidth': '1.3',
                                                        'strokeLinecap': 'round',
                                                        'strokeLinejoin': 'round'
                                                    }))] : null), _createElement('a', {
                                                    'className': 'facetentrykey',
                                                    'tabIndex': '0',
                                                    'role': 'listitem'
                                                }, this.value), _createElement('div', { 'className': 'facetentryval' }, this.hitCount));
                                            }, { count: undefined })];
                                    }
                                    function repeatValues2(Values, ValuesIndex) {
                                        return [Values(function () {
                                                return _createElement('div', { 'className': 'facetdiv ' + this.facetDivClass }, _createElement('div', { 'className': 'facet-checkbox' }, _createElement('input', {
                                                    'type': 'checkbox',
                                                    'className': 'cm_facet_checkbox',
                                                    'readOnly': true,
                                                    'checked': this.isSelected
                                                }), !this.isSelected ? [_createElement('svg', {
                                                        'className': 'cm_unchecked',
                                                        'width': '1.6rem',
                                                        'height': '1.6rem',
                                                        'viewBox': '0 0 16 16',
                                                        'aria-hidden': 'true',
                                                        'focusable': 'false',
                                                        'key': '1930'
                                                    }, _createElement('rect', {
                                                        'x': '1',
                                                        'y': '1',
                                                        'width': '14',
                                                        'height': '14',
                                                        'stroke': 'currentColor',
                                                        'fill': 'none',
                                                        'strokeWidth': '1',
                                                        'vectorEffect': 'non-scaling-stroke'
                                                    }))] : null, this.isSelected ? [_createElement('svg', {
                                                        'className': 'cm_checked icon icon-checkmark',
                                                        'aria-hidden': 'true',
                                                        'xmlns': 'http://www.w3.org/2000/svg',
                                                        'width': '22',
                                                        'height': '23',
                                                        'viewBox': '0 0 22 23',
                                                        'fill': 'none',
                                                        'key': '5030'
                                                    }, _createElement('path', {
                                                        'd': 'M18.3327 5.82227L8.24935 15.9056L3.66602 11.3223',
                                                        'stroke': 'white',
                                                        'strokeWidth': '1.3',
                                                        'strokeLinecap': 'round',
                                                        'strokeLinejoin': 'round'
                                                    }))] : null), _createElement('a', {
                                                    'className': 'facetentrykey',
                                                    'tabIndex': '0',
                                                    'role': 'listitem'
                                                }, this.value), _createElement('div', { 'className': 'facetentryval' }, this.hitCount));
                                            }, { count: undefined })];
                                    }
                                    function repeatValues3(Values, ValuesIndex) {
                                        return [Values(function () {
                                                return _createElement('div', { 'className': 'facetdiv ' + this.facetDivClass }, _createElement('div', { 'className': 'facet-checkbox' }, _createElement('input', {
                                                    'type': 'checkbox',
                                                    'className': 'cm_facet_checkbox',
                                                    'readOnly': true,
                                                    'checked': this.isSelected
                                                }), !this.isSelected ? [_createElement('svg', {
                                                        'className': 'cm_unchecked',
                                                        'width': '1.6rem',
                                                        'height': '1.6rem',
                                                        'viewBox': '0 0 16 16',
                                                        'aria-hidden': 'true',
                                                        'focusable': 'false',
                                                        'key': '1930'
                                                    }, _createElement('rect', {
                                                        'x': '1',
                                                        'y': '1',
                                                        'width': '14',
                                                        'height': '14',
                                                        'stroke': 'currentColor',
                                                        'fill': 'none',
                                                        'strokeWidth': '1',
                                                        'vectorEffect': 'non-scaling-stroke'
                                                    }))] : null, this.isSelected ? [_createElement('svg', {
                                                        'className': 'cm_checked icon icon-checkmark',
                                                        'aria-hidden': 'true',
                                                        'xmlns': 'http://www.w3.org/2000/svg',
                                                        'width': '22',
                                                        'height': '23',
                                                        'viewBox': '0 0 22 23',
                                                        'fill': 'none',
                                                        'key': '5030'
                                                    }, _createElement('path', {
                                                        'd': 'M18.3327 5.82227L8.24935 15.9056L3.66602 11.3223',
                                                        'stroke': 'white',
                                                        'strokeWidth': '1.3',
                                                        'strokeLinecap': 'round',
                                                        'strokeLinejoin': 'round'
                                                    }))] : null), !this.isCustomRange ? [
                                                    _createElement('a', {
                                                        'className': 'facetentrykey',
                                                        'tabIndex': '0',
                                                        'role': 'listitem',
                                                        'key': '8741'
                                                    }, _createElement('span', {}, this.value)),
                                                    _createElement('div', {
                                                        'className': 'facetentryval',
                                                        'key': '8743'
                                                    }, this.hitCount)
                                                ] : null, this.isCustomRange ? [_createElement('a', {
                                                        'className': 'facetentrykey',
                                                        'tabIndex': '0',
                                                        'role': 'listitem',
                                                        'key': '11101'
                                                    }, this.finite ? _createElement('span', { 'key': '1223' }, this.range[0], ' - ', this.range[1]) : null, this.toPosInf ? _createElement('span', { 'key': '1300' }, this.range[0], ' ', _translate(`ranged_facet_more`)) : null, this.toNegInf ? _createElement('span', { 'key': '1396' }, this.range[1], ' ', _translate(`ranged_facet_less`)) : null)] : null);
                                            }, { count: undefined })];
                                    }
                                    function repeatShowAlwaysValues4(ShowAlwaysValues, ShowAlwaysValuesIndex) {
                                        return [ShowAlwaysValues(function () {
                                                function scopeStarFill1(i, iIndex) {
                                                    var starFill = this.value - i;
                                                    return _createElement('span', {
                                                        'key': i,
                                                        'className': 'cm_star cm_star__' + (starFill < 0.25 ? 'empty' : starFill < 0.75 ? 'half' : 'full')
                                                    });
                                                }
                                                function repeatI2(i, iIndex, starFill) {
                                                    return scopeStarFill1.apply(this, [
                                                        i,
                                                        iIndex
                                                    ]);
                                                }
                                                return _createElement('div', { 'className': 'facetdiv ' + this.facetDivClass }, _createElement('input', {
                                                    'type': 'checkbox',
                                                    'className': 'cm_facet_checkbox',
                                                    'readOnly': true,
                                                    'checked': this.isSelected
                                                }), _createElement('a', {
                                                    'className': 'facetentrykey',
                                                    'tabIndex': '0',
                                                    'role': 'listitem'
                                                }, _createElement.apply(this, [
                                                    'span',
                                                    { 'className': 'cm_review-stars' },
                                                    _map([
                                                        0,
                                                        1,
                                                        2,
                                                        3,
                                                        4
                                                    ], repeatI2.bind(this))
                                                ]), this.value !== '5' ? _createElement('span', {
                                                    'className': 'cm_and-up',
                                                    'key': '499'
                                                }, ' and up') : null), _createElement('div', { 'className': 'facetentryval' }, this.hitCount));
                                            }, { count: undefined })];
                                    }
                                    function repeatValues5(Values, ValuesIndex) {
                                        return [Values(function () {
                                                function scopeStarFill1(i, iIndex) {
                                                    var starFill = this.value - i;
                                                    return _createElement('span', {
                                                        'key': i,
                                                        'className': 'cm_star cm_star__' + (starFill < 0.25 ? 'empty' : starFill < 0.75 ? 'half' : 'full')
                                                    });
                                                }
                                                function repeatI2(i, iIndex, starFill) {
                                                    return scopeStarFill1.apply(this, [
                                                        i,
                                                        iIndex
                                                    ]);
                                                }
                                                return _createElement('div', { 'className': 'facetdiv ' + this.facetDivClass }, _createElement('input', {
                                                    'type': 'checkbox',
                                                    'className': 'cm_facet_checkbox',
                                                    'readOnly': true,
                                                    'checked': this.isSelected
                                                }), _createElement('a', {
                                                    'className': 'facetentrykey',
                                                    'tabIndex': '0',
                                                    'role': 'listitem'
                                                }, _createElement.apply(this, [
                                                    'span',
                                                    { 'className': 'cm_review-stars' },
                                                    _map([
                                                        0,
                                                        1,
                                                        2,
                                                        3,
                                                        4
                                                    ], repeatI2.bind(this))
                                                ]), this.value !== '5' ? _createElement('span', {
                                                    'className': 'cm_and-up',
                                                    'key': '499'
                                                }, ' and up') : null), _createElement('div', { 'className': 'facetentryval' }, this.hitCount));
                                            }, { count: undefined })];
                                    }
                                    return _createElement('div', { 'className': 'facetholder cm_field-' + this.field }, this.template !== 'toggleFacet' ? [
                                        _createElement('div', {
                                            'className': 'facettitle',
                                            'data-cm-role': 'toggle-facet',
                                            'tabIndex': '0',
                                            'key': '561'
                                        }, _createElement('span', {}, this.name), this.isCollapsed ? [_createElement('svg', {
                                                'className': 'cm_icon cm_icon-angle left',
                                                'height': '20px',
                                                'role': 'img',
                                                'viewBox': '39 30 565 565',
                                                'aria-hidden': 'true',
                                                'key': '2380'
                                            }, _createElement('path', { 'd': 'M600,189q0-7-6-12l-28-28q-5-6-12-6t-13,6l-220,219-219-219q-5-6-13-6t-12,6l-28,28q-6,5-6,12t6,13l260,260q5,6,12,6t13-6l260-260q6-5,6-13z' }))] : null, !this.isCollapsed ? [_createElement('svg', {
                                                'className': 'cm_icon cm_icon-angle down',
                                                'height': '20px',
                                                'role': 'img',
                                                'viewBox': '39 30 565 565',
                                                'aria-hidden': 'true',
                                                'key': '5590'
                                            }, _createElement('path', { 'd': 'M600,189q0-7-6-12l-28-28q-5-6-12-6t-13,6l-220,219-219-219q-5-6-13-6t-12,6l-28,28q-6,5-6,12t6,13l260,260q5,6,12,6t13-6l260-260q6-5,6-13z' }))] : null),
                                        _createElement('div', {
                                            'className': 'facetbody' + (this.template === 'simpleFacet' && this.needShowMore && !this.moreValuesToShow ? ' expanded' : ''),
                                            'key': '563'
                                        }, this.template === 'simpleFacet' ? _createElement('div', {
                                            'role': 'list',
                                            'className': 'cmTemplate_simpleFacet',
                                            'key': '1073'
                                        }, this.showFilterInput ? _createElement('div', {
                                            'className': 'filter-input',
                                            'key': '1171'
                                        }, [this.filterInput(function () {
                                                return _createElement('div', {
                                                    'className': 'input  cm_filterInput',
                                                    'placeholder': _translate(`facet_filter_placeholder`)
                                                });
                                            }, {
                                                widgetName: 'undefined',
                                                items: undefined
                                            })], this.inputNotEmpty ? _createElement('span', {
                                            'className': 'filter-input_clear-container',
                                            'onClick': this.clearInput,
                                            'key': '1510'
                                        }, _createElement('span', { 'className': 'filter-input_clear' }, '\u2715')) : null) : null, !this.ShowAlwaysValues.length && !this.Values.length ? [_createElement('div', {
                                                'className': 'facetdiv',
                                                'key': '16791'
                                            }, _createElement('span', { 'className': 'facetentrykey' }, _translate(`facet_filter_nothing`)))] : null, _createElement('div', { 'className': 'facetvalues' + (this.showFilterInput && !this.moreValuesToShow ? ' overflowed' : '') }, _createElement.apply(this, [
                                            'div',
                                            { 'className': 'cmRepeater_ShowAlwaysValues' },
                                            _map(this.ShowAlwaysValues, repeatShowAlwaysValues1.bind(this))
                                        ]), _createElement.apply(this, [
                                            'div',
                                            { 'className': 'cmRepeater_Values' },
                                            _map(this.Values, repeatValues2.bind(this))
                                        ]), this.needShowMore ? _createElement('div', {
                                            'className': 'facetdiv cm_show-all-container',
                                            'key': '6473'
                                        }, _createElement('a', {
                                            'className': 'cm_show-all',
                                            'data-cm-role': 'toggle-show-more',
                                            'tabIndex': '0'
                                        }, this.moreValuesToShow ? [_translate(`show_more`, {  valuesCount : this. valuesCount  })] : null, !this.moreValuesToShow ? [_translate(`show_less`)] : null)) : null)) : null, this.template === 'selectFacet' ? _createElement('div', {
                                            'className': 'cmTemplate_selectFacet',
                                            'key': '6852'
                                        }, [this.select(function () {
                                                function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                                                    return _createElement('option', {
                                                        'disabled': this.loading,
                                                        'value': entry.term,
                                                        'key': entry.value
                                                    }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                                                }
                                                function repeatEntry2(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                                                    return _createElement('option', {
                                                        'disabled': this.loading,
                                                        'value': entry.term,
                                                        'key': entry.value
                                                    }, '\n          ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n        ');
                                                }
                                                function scopePopularEntriesUnpopularEntriesIsPopularField3() {
                                                    var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                                                    var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                                                    var isPopularField = popularEntries.length && unpopularEntries.length;
                                                    return [
                                                        !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                                                            'value': '',
                                                            'key': 'null-option'
                                                        }, '\n          ', _translate(`select_title`), ' ', this.title, '\n        ') : null,
                                                        this.loading ? _createElement('option', {
                                                            'key': 'loading-option',
                                                            'disabled': true
                                                        }, _translate(`select_loading`)) : null,
                                                        isPopularField ? [
                                                            _createElement('option', {
                                                                'className': 'cm_option_title cm_option-popular',
                                                                'disabled': true,
                                                                'key': '11731'
                                                            }, _translate(`ymm_bar_popular`)),
                                                            _map(popularEntries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField)),
                                                            _createElement('option', {
                                                                'className': 'cm_option_title cm_option-unpopular',
                                                                'disabled': true,
                                                                'key': '11734'
                                                            }, _translate(`ymm_bar_unpopular`))
                                                        ] : null,
                                                        _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, popularEntries, unpopularEntries, isPopularField))
                                                    ];
                                                }
                                                function scopeShowSelectedValues4() {
                                                    var showSelectedValues = this.selectedEntries.length;
                                                    return _createElement('option', {
                                                        'key': '_current',
                                                        'value': '_current'
                                                    }, showSelectedValues ? [this.selectedEntries.map(e => e.value).join(', ')] : null, !showSelectedValues ? [
                                                        _translate(`select_title`),
                                                        ' ',
                                                        this.title
                                                    ] : null);
                                                }
                                                function repeatEntry5(entry, index) {
                                                    return _createElement('div', {
                                                        'className': 'option' + (this.isSearchable && this.activeIndex === index || !this.isSearchable && entry.selected ? ' cm_checked' : ''),
                                                        'key': entry.value,
                                                        'onClick': () => this.onChange(entry.term)
                                                    }, this.showCheckboxes ? _createElement('input', {
                                                        'type': 'checkbox',
                                                        'readOnly': true,
                                                        'checked': entry.selected,
                                                        'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                                                        'key': '3395'
                                                    }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                                                        'className': 'cm_dropdown_hitCount',
                                                        'key': '3597'
                                                    }, entry.hitCount) : null);
                                                }
                                                return _createElement('div', { 'className': 'cm_select' }, _createElement('div', { 'className': this.extraClassName }, !this.isSearchable ? _createElement('div', {
                                                    'className': 'cm_select_toggle' + (this.useNativeDropdown ? ' cm_select_toggle__native' : '') + ' cm_toggle-dropdown',
                                                    'key': '62'
                                                }, _createElement('select', {
                                                    'className': 'cm_select_inner-select ' + (this.firstSelectedTerm ? 'cm_selected' : ''),
                                                    'onChange': this.onChange,
                                                    'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                                                    'disabled': this.disabled,
                                                    'aria-label': this.title
                                                }, this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, []) : null, !this.useNativeDropdown ? scopeShowSelectedValues4.apply(this, []) : null)) : null, this.isSearchable ? [[this.filterInput(function () {
                                                            return _createElement('div', { 'className': 'cm_filterInput' });
                                                        }, {
                                                            widgetName: 'undefined',
                                                            items: undefined
                                                        })]] : null, !this.disabled && !this.useNativeDropdown ? _createElement.apply(this, [
                                                    'div',
                                                    {
                                                        'className': 'cm_dropdown cm_select_dropdown cm_hide',
                                                        'aria-label': this.title,
                                                        'key': '2657'
                                                    },
                                                    !this.hideNullOption ? _createElement('div', {
                                                        'className': 'option',
                                                        'key': 'null-option',
                                                        'onClick': () => this.onChange('')
                                                    }, '\n      ', _translate(`select_title`), ' ', this.title, '\n    ') : null,
                                                    this.loading ? _createElement('div', {
                                                        'className': 'option',
                                                        'key': 'null-option',
                                                        'disabled': true
                                                    }, _translate(`select_loading`)) : null,
                                                    !this.loading ? _map(this.entries, repeatEntry5.bind(this)) : null
                                                ]) : null));
                                            }, {
                                                widgetName: 'undefined',
                                                items: undefined
                                            })]) : null, this.template === 'priceFacet' ? _createElement('div', {
                                            'role': 'list',
                                            'className': 'cmTemplate_priceFacet',
                                            'key': '12756'
                                        }, !this.ranges.length ? [
                                            _createElement('div', { 'key': '128521' }, this.selectedRawRange[0], ' ', _translate(`ranged_facet_range_delimiter`), ' ', this.selectedRawRange[1]),
                                            '\n  ',
                                            this.slider,
                                            '\n  ',
                                            _createElement('div', {
                                                'className': 'cm_flex',
                                                'key': '128523'
                                            }, _createElement('div', { 'className': 'cm_flex-grow' }, _translate(`ranged_facet_min`), ' ', this.rawMin), _createElement('div', {}, _translate(`ranged_facet_max`), ' ', this.rawMax))
                                        ] : null, this.ranges.length ? [_createElement.apply(this, [
                                                'div',
                                                {
                                                    'className': 'cmRepeater_Values',
                                                    'key': '132171'
                                                },
                                                _map(this.Values, repeatValues3.bind(this))
                                            ])] : null, [this.Inputs(function () {
                                                return _createElement('div', { 'className': 'input cm_Inputs' }, [this.inputMin(function () {
                                                        return _createElement('div', {
                                                            'placeholder': _translate(`ranged_facet_min`),
                                                            'className': 'cm_inputMin'
                                                        });
                                                    }, {
                                                        widgetName: 'undefined',
                                                        items: undefined
                                                    })], _createElement('span', { 'className': 'separator' }, _translate(`ranged_facet_inputs_delimiter`)), [this.inputMax(function () {
                                                        return _createElement('div', {
                                                            'placeholder': _translate(`ranged_facet_max`),
                                                            'className': 'cm_inputMax'
                                                        });
                                                    }, {
                                                        widgetName: 'undefined',
                                                        items: undefined
                                                    })], _createElement('button', {
                                                    'type': 'button',
                                                    'className': 'cm_btn cm_button cm_button__secondary',
                                                    'onClick': this.setCustomRange
                                                }, '\n    ', _translate(`ranged_facet_submit`), '\n  '));
                                            }, {
                                                widgetName: 'undefined',
                                                items: undefined
                                            })]) : null, this.template === 'sliderFacet' ? _createElement('div', {
                                            'className': 'cmTemplate_sliderFacet',
                                            'key': '17389'
                                        }, _createElement('div', { 'className': 'facetslider' }, _createElement('div', { 'className': 'facetsliderinfo' }, '\n    ', _translate(`ranged_facet_selected_label`), ' ', this.selectedRange[0], ' ', _translate(`ranged_facet_range_delimiter`), '\n    ', this.selectedRange[1], '\n  '), '\n  ', this.slider, '\n  ', _createElement('div', { 'className': 'cm_slider-bounds' }, _createElement('div', { 'className': 'min' }, this.min), _createElement('div', { 'className': 'max' }, this.max), _createElement('div', { 'className': 'clear' }))), [this.Inputs(function () {
                                                return _createElement('div', { 'className': 'input cm_Inputs' }, this.inputMin ? [[this.inputMin(function () {
                                                            return _createElement('div', {
                                                                'placeholder': _translate(`ranged_facet_min`),
                                                                'className': 'cm_inputMin'
                                                            });
                                                        }, {
                                                            widgetName: 'undefined',
                                                            items: undefined
                                                        })]] : null, this.inputMin && this.inputMax ? _createElement('span', {
                                                    'className': 'separator',
                                                    'key': '347'
                                                }, _translate(`ranged_facet_inputs_delimiter`)) : null, this.inputMax ? [[this.inputMax(function () {
                                                            return _createElement('div', {
                                                                'placeholder': _translate(`ranged_facet_max`),
                                                                'className': 'cm_inputMax'
                                                            });
                                                        }, {
                                                            widgetName: 'undefined',
                                                            items: undefined
                                                        })]] : null, _createElement('button', {
                                                    'type': 'button',
                                                    'className': 'cm_btn cm_button cm_button__secondary',
                                                    'onClick': this.setCustomRange
                                                }, '\n    ', _translate(`ranged_facet_submit`), '\n  '));
                                            }, {
                                                widgetName: 'undefined',
                                                items: undefined
                                            })]) : null, this.template === 'reviewFacet' ? _createElement('div', {
                                            'role': 'list',
                                            'className': 'cmTemplate_reviewFacet',
                                            'key': '19073'
                                        }, _createElement.apply(this, [
                                            'div',
                                            { 'className': 'cmRepeater_ShowAlwaysValues' },
                                            _map(this.ShowAlwaysValues, repeatShowAlwaysValues4.bind(this))
                                        ]), _createElement.apply(this, [
                                            'div',
                                            { 'className': 'cmRepeater_Values' },
                                            _map(this.Values, repeatValues5.bind(this))
                                        ])) : null)
                                    ] : null, this.template === 'toggleFacet' ? _createElement('div', {
                                        'className': 'cmTemplate_toggleFacet',
                                        'key': '22163'
                                    }, _createElement('div', { 'className': 'facettitle cm_facet-toggle' }, _createElement('span', {}, this.name), _createElement('label', { 'className': 'cm_facet-toggle_switch' }, _createElement('input', {
                                        'className': 'cm_facet-toggle_input',
                                        'type': 'checkbox',
                                        'checked': this.isToggled,
                                        'onClick': this.toggleFacet
                                    }), _createElement('span', { 'className': 'cm_facet-toggle_slider' })))) : null);
                                }, { count: undefined })];
                        }
                        return _createElement('div', { 'className': 'cm_facets' }, _createElement.apply(this, [
                            'div',
                            { 'className': 'cmRepeater_facets' },
                            _map(this.facets, repeatFacets1.bind(this))
                        ]));
                    }, {
                        widgetName: 'undefined',
                        items: undefined
                    })]);
            }, {
                widgetName: 'undefined',
                items: undefined
            })])], _createElement('div', { 'className': 'cm_main-content' }, scopeIsB2BShowExactFitBadgeShowLoadMore1.apply(this, [])));
}
        export const componentNames = ["cm:FilterSearchBox","cm:filterInput","cm:VehicleSpecs","cm:filterChips","cm:FilterChips","cm:filterInput","cm:FacetBarWheels","cm:filterInput","cm:FacetBarTires","cm:filterInput","cm:filterInput","cm:select","cm:inputMin","cm:inputMax","cm:Inputs","cm:inputMin","cm:inputMax","cm:Inputs","cm:facets","cm:Facets","cm:FilterSearchBox","cm:message","cm:customMessage","cm:dialogButton","cm:facetDialogButton","cm:SearchHeader","cm:filterChips","cm:FilterChips","cm:message","cm:pagination","cm:loadMoreButton","cm:loadMore","cm:SearchResult"]